"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processmap = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
const ej2_diagrams_1 = require("@syncfusion/ej2-diagrams");
require("@syncfusion/ej2-diagrams/styles/diagram/bootstrap.css");
require("@syncfusion/ej2-diagrams/styles/diagram/fabric.css");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/List/List");
const List_1 = require("../../../TdWebtoolkitControls/controls/List/List");
require("../../../TdWebtoolkitControls/controls/Tabs/Tabs");
const CheckSecurity_1 = require("../../../TdWebtoolkitControls/javascript/CheckSecurity");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Base_1 = require("../../../TdWebtoolkitControls/model/Base");
const Instance_1 = require("../../../TdWebtoolkitControls/model/Instance");
const ModificationInfo_1 = require("../../../TdWebtoolkitControls/model/ModificationInfo");
require("./processmap.tmpl.less");
const $ = require("jquery");
const m = require("../SynView");
var ProcessShapeId;
(function (ProcessShapeId) {
    ProcessShapeId[ProcessShapeId["ProcessSquare"] = 0] = "ProcessSquare";
    ProcessShapeId[ProcessShapeId["ProcessRight"] = 1] = "ProcessRight";
    ProcessShapeId[ProcessShapeId["ProcessDown"] = 2] = "ProcessDown";
    ProcessShapeId[ProcessShapeId["ProcessLeft"] = 3] = "ProcessLeft";
    ProcessShapeId[ProcessShapeId["ProcessUp"] = 4] = "ProcessUp";
    ProcessShapeId[ProcessShapeId["ProcessArrowRight"] = 5] = "ProcessArrowRight";
    ProcessShapeId[ProcessShapeId["ProcessArrowDown"] = 6] = "ProcessArrowDown";
    ProcessShapeId[ProcessShapeId["ProcessArrowLeft"] = 7] = "ProcessArrowLeft";
    ProcessShapeId[ProcessShapeId["ProcessArrowUp"] = 8] = "ProcessArrowUp";
    ProcessShapeId[ProcessShapeId["ProcessSub"] = 9] = "ProcessSub";
})(ProcessShapeId || (ProcessShapeId = {}));
var DesignShapeId;
(function (DesignShapeId) {
    DesignShapeId[DesignShapeId["Text"] = 0] = "Text";
    DesignShapeId[DesignShapeId["Circle"] = 1] = "Circle";
    DesignShapeId[DesignShapeId["Square"] = 2] = "Square";
    DesignShapeId[DesignShapeId["Arrow"] = 3] = "Arrow";
    DesignShapeId[DesignShapeId["ArrowFlipped"] = 4] = "ArrowFlipped";
    DesignShapeId[DesignShapeId["DesignRight"] = 5] = "DesignRight";
    DesignShapeId[DesignShapeId["DesignDown"] = 6] = "DesignDown";
    DesignShapeId[DesignShapeId["DesignLeft"] = 7] = "DesignLeft";
    DesignShapeId[DesignShapeId["DesignUp"] = 8] = "DesignUp";
    DesignShapeId[DesignShapeId["DesignArrowRight"] = 9] = "DesignArrowRight";
    DesignShapeId[DesignShapeId["DesignArrowDown"] = 10] = "DesignArrowDown";
    DesignShapeId[DesignShapeId["DesignArrowLeft"] = 11] = "DesignArrowLeft";
    DesignShapeId[DesignShapeId["DesignArrowUp"] = 12] = "DesignArrowUp";
})(DesignShapeId || (DesignShapeId = {}));
var StepShapeId;
(function (StepShapeId) {
    StepShapeId[StepShapeId["StepSquare"] = 0] = "StepSquare";
    StepShapeId[StepShapeId["StepRight"] = 1] = "StepRight";
    StepShapeId[StepShapeId["StepDown"] = 2] = "StepDown";
    StepShapeId[StepShapeId["StepStartEnd"] = 3] = "StepStartEnd";
    StepShapeId[StepShapeId["StepDecision"] = 4] = "StepDecision";
})(StepShapeId || (StepShapeId = {}));
var ConnectorId;
(function (ConnectorId) {
    ConnectorId[ConnectorId["Orthogonal"] = 0] = "Orthogonal";
    ConnectorId[ConnectorId["Straight"] = 1] = "Straight";
})(ConnectorId || (ConnectorId = {}));
var ViewMode;
(function (ViewMode) {
    ViewMode[ViewMode["ProcessView"] = 0] = "ProcessView";
    ViewMode[ViewMode["StepsView"] = 1] = "StepsView";
})(ViewMode || (ViewMode = {}));
class processmap extends m.SynView {
    //#region Controls
    //#endregion Controls
    //#endregion MEMBER letIABLES
    //#region CONTRUCTORS
    constructor() {
        super();
        //#region MEMBER letIABLES
        this.m_bredCrumpList = [];
        this.m_categoryList = [];
        this.m_hasContextMenu = false;
    }
    //#endregion CONTRUCTORS
    //#region MEMBER METHODS
    //#region Inherited from SynView
    // Initialization of member letiables
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-sitemap fa-rotate-270";
        this.m_SingleProcessMapMode = false;
        this.m_resetInstance = true;
        this.m_fullInitDone = false;
        this.m_diagramChanged = false;
        this.m_readonly = false;
        this.m_typeIdProcessMap = "999999910";
        this.m_typeIdProcess = "999999911";
        this.m_typeIdProcessStep = "999999912";
        // Initialize the processShapes for the symbol palette
        this.m_processShapes = [
            {
                id: ProcessShapeId[ProcessShapeId.ProcessSquare],
                shape: {
                    type: "Path",
                    data: "M0 0 L200 0 L200 200 L0 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessSquare],
                },
            },
            {
                id: ProcessShapeId[ProcessShapeId.ProcessRight],
                shape: {
                    type: "Path",
                    data: "M0 0 L85 0 L110 100 L85 200 L0 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessRight],
                },
            },
            {
                id: ProcessShapeId[ProcessShapeId.ProcessDown],
                shape: {
                    type: "Path",
                    data: "M0 0 L200 0 L200 85 L100 110 L0 85 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessDown],
                },
            },
            {
                id: ProcessShapeId[ProcessShapeId.ProcessLeft],
                shape: {
                    type: "Path",
                    data: "M0 100 L25 0 L110 0 L110 200 L25 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessLeft],
                },
            },
            {
                id: ProcessShapeId[ProcessShapeId.ProcessUp],
                shape: {
                    type: "Path",
                    data: "M0 25 L100 0 L200 25 L200 110 L0 110 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessUp],
                },
            },
            {
                id: ProcessShapeId[ProcessShapeId.ProcessArrowRight],
                shape: {
                    type: "Path",
                    data: "M0 0 L85 0 L110 100 L85 200 L0 200 L25 100 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessArrowRight],
                },
            },
            {
                id: ProcessShapeId[ProcessShapeId.ProcessArrowDown],
                shape: {
                    type: "Path",
                    data: "M0 0 L100 25 L200 0 L200 85 L100 110 L0 85 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessArrowDown],
                },
            },
            {
                id: ProcessShapeId[ProcessShapeId.ProcessArrowLeft],
                shape: {
                    type: "Path",
                    data: "M0 100 L25 0 L110 0 L85 100 L110 200 L25 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessArrowLeft],
                },
            },
            {
                id: ProcessShapeId[ProcessShapeId.ProcessArrowUp],
                shape: {
                    type: "Path",
                    data: "M0 25 L100 0 L200 25 L200 110 L100 85 L0 110 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessArrowUp],
                },
            },
            {
                id: ProcessShapeId[ProcessShapeId.ProcessSub],
                shape: {
                    type: "Flow",
                    shape: "PreDefinedProcess",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: ProcessShapeId[ProcessShapeId.ProcessSub],
                },
            },
        ];
        // Initialize the designShapes for the symbol palette
        this.m_designShapes = [
            {
                id: DesignShapeId[DesignShapeId.Text],
                shape: {
                    type: "Path",
                    data: "M0 0 L200 0 L200 200 L0 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "none", fontSize: 12, bold: false, }, content: "Aa", }],
                style: {
                    strokeColor: "none",
                    fill: "none",
                },
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.Text],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.Circle],
                shape: {
                    type: "Path",
                    data: "M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.Circle],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.Square],
                shape: {
                    type: "Path",
                    data: "M0 0 L200 0 L200 200 L0 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.Square],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.Arrow],
                shape: {
                    type: "Path",
                    data: "M0 25 L25 0 L25 15 L40 15 C200 15 200 185 40 185 L25 185 L25 165 L40 165 C175 165 175 35 40 35 L25 35 L25 50 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.Arrow],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.ArrowFlipped],
                shape: {
                    type: "Path",
                    data: "M25 15 L40 15 C200 15 200 185 40 185 L25 185 L25 200 L0 175 L25 150 L25 165 L40 165 C175 165 175 35 40 35 L25 35 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.ArrowFlipped],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.DesignRight],
                shape: {
                    type: "Path",
                    data: "M0 0 L85 0 L110 100 L85 200 L0 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.DesignRight],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.DesignDown],
                shape: {
                    type: "Path",
                    data: "M0 0 L200 0 L200 85 L100 110 L0 85 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.DesignDown],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.DesignLeft],
                shape: {
                    type: "Path",
                    data: "M0 100 L25 0 L110 0 L110 200 L25 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.DesignLeft],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.DesignUp],
                shape: {
                    type: "Path",
                    data: "M0 25 L100 0 L200 25 L200 110 L0 110 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.DesignUp],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.DesignArrowRight],
                shape: {
                    type: "Path",
                    data: "M0 0 L85 0 L110 100 L85 200 L0 200 L25 100 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.DesignArrowRight],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.DesignArrowDown],
                shape: {
                    type: "Path",
                    data: "M0 0 L100 25 L200 0 L200 85 L100 110 L0 85 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.DesignArrowDown],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.DesignArrowLeft],
                shape: {
                    type: "Path",
                    data: "M0 100 L25 0 L110 0 L85 100 L110 200 L25 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.DesignArrowLeft],
                },
            },
            {
                id: DesignShapeId[DesignShapeId.DesignArrowUp],
                shape: {
                    type: "Path",
                    data: "M0 25 L100 0 L200 25 L200 110 L100 85 L0 110 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    isDesignShape: true,
                    shapeId: DesignShapeId[DesignShapeId.DesignArrowUp],
                },
            },
        ];
        // Initialize the stepsShapes for the symbol palette
        this.m_stepsShapes = [
            {
                id: StepShapeId[StepShapeId.StepSquare],
                shape: {
                    type: "Path",
                    data: "M0 0 L200 0, L200 200 L0 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: StepShapeId[StepShapeId.StepSquare],
                },
            },
            {
                id: StepShapeId[StepShapeId.StepRight],
                shape: {
                    type: "Path",
                    data: "M0 0 L85 0 L110 100 L85 200 L0 200 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: StepShapeId[StepShapeId.StepRight],
                },
            },
            {
                id: StepShapeId[StepShapeId.StepDown],
                shape: {
                    type: "Path",
                    data: "M0 0 L200 0 L200 85 L100 110 L0 85 Z",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: StepShapeId[StepShapeId.StepDown],
                },
            },
            {
                id: StepShapeId[StepShapeId.StepStartEnd],
                shape: {
                    type: "Flow",
                    data: "Terminator",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: StepShapeId[StepShapeId.StepStartEnd],
                },
                height: 100,
                width: 200,
            },
            {
                id: StepShapeId[StepShapeId.StepDecision],
                shape: {
                    type: "Flow",
                    shape: "Decision",
                },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
                data: {
                    shapeId: StepShapeId[StepShapeId.StepDecision],
                },
            },
        ];
        // Initialize the connectors for the connector palette
        // Important: No data property to save the shapeId. id must be connector type! (So only two connectors possible)
        this.m_connectors = [
            {
                id: "Orthogonal", type: "Orthogonal", sourcePoint: { x: 0, y: 0 }, targetPoint: { x: 60, y: 60 },
                targetDecorator: { shape: "Arrow" }, style: { strokeWidth: 1 },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
            },
            {
                id: "Straight", type: "Straight", sourcePoint: { x: 0, y: 0 }, targetPoint: { x: 60, y: 60 },
                targetDecorator: { shape: "Arrow" }, style: { strokeWidth: 1 },
                annotations: [{ style: { color: "#245c86", fill: "transparent", fontSize: 12, bold: false, }, }],
            },
        ];
        this.m_colorPickerFill;
        this.m_colorPickerText;
        this.m_viewMode;
        this.m_processMapRelIdProcesses = Utilities_1.synUtil.Configs.getValueMandatory("processmap.processmap.relidprocesses");
        this.m_processRelIdProcesses = Utilities_1.synUtil.Configs.getValueMandatory("processmap.process.relidprocesses");
        this.m_processRelIdProcessSteps = Utilities_1.synUtil.Configs.getValueMandatory("processmap.process.relidprocesssteps");
        this.m_stepRelIdPrevNextStep = Utilities_1.synUtil.Configs.getValueMandatory("processmap.step.relidprevnextstep");
        this.m_layoutSaveFailed = false;
        this.m_keepAspectRatio = false;
        this.m_copiedDiagramNodeStyle;
        // Inject Diagram modules
        ej2_diagrams_1.Diagram.Inject(ej2_diagrams_1.UndoRedo, ej2_diagrams_1.PrintAndExport, ej2_diagrams_1.Snapping);
    }
    getParametersFromUrl() {
        super.getParametersFromUrl();
        // Necessary so the DOM has time to update on first load
        window.setTimeout(() => tslib_1.__awaiter(this, void 0, void 0, function* () { yield this.setInstanceAsync(); }), 0);
    }
    forceRefresh(modificationInfo) {
        let that = this;
        let fullRefresh = false;
        if (!modificationInfo) {
            fullRefresh = true;
        }
        else {
            if (modificationInfo.fullRefreshNecessary)
                fullRefresh = true;
            else {
                if (modificationInfo.modifiedInstances) {
                    if (that.m_$searchList && that.m_$searchList.synList("isInitialized"))
                        that.m_$searchList.synList("update", modificationInfo.modifiedInstances);
                    if (that.m_$tabs && that.m_$tabs.synTabs("isInitialized"))
                        that.m_$tabs.synTabs("update", modificationInfo.modifiedInstances);
                }
                else if (modificationInfo.deletions) {
                    if (modificationInfo.deletions.action === ModificationInfo_1.ModificationAction.Object) {
                        if (that.m_$searchList && that.m_$searchList.synList("isInitialized"))
                            that.m_$searchList.synList("delete", modificationInfo.deletions.instances);
                        if (that.m_$tabs && that.m_$tabs.synTabs("isInitialized"))
                            that.m_$tabs.synTabs("delete", modificationInfo.deletions.instances);
                    }
                    else if (modificationInfo.deletions.action === ModificationInfo_1.ModificationAction.Link && modificationInfo.deletions.parent) {
                        if (that.m_$searchList && that.m_$searchList.synList("isInitialized"))
                            that.m_$searchList.synList("delete", modificationInfo.deletions.instances);
                        if (that.m_$tabs && that.m_$tabs.synTabs("isInitialized"))
                            that.m_$tabs.synTabs("unlinkAsync", modificationInfo.deletions.instances, modificationInfo.deletions.parent, modificationInfo.deletions.relation);
                    }
                }
                else if (modificationInfo.new)
                    fullRefresh = true;
            }
        }
        if (fullRefresh) {
            if (that.m_$searchList && that.m_$searchList.synList("isInitialized"))
                that.m_$searchList.synList("refresh");
            if (that.m_$tabs && that.m_$tabs.synTabs("isInitialized"))
                that.m_$tabs.synTabs("refreshCurrentTab");
        }
    }
    resizeControls() {
        let that = this;
        if (that.m_diagram)
            that.m_diagram.updateViewPort();
        //if (that.m_$tabs)
        //    that.m_$tabs.synTabs("fitHeight");
    }
    renderContents() {
        let that = this;
        that.m_$searchList = $("#searchList");
        that.m_$tabs = $("#processMapRelationTabs");
        that.mapCategories();
        that.m_$tabs
            .on('dataBound', function () { that.raiseOnViewResize(); })
            .on('instanceChanged', function () { that.raiseOnViewResize(); })
            .on('selectionChanged', (event, parentId, parentRelId, ids) => {
            if (parentId != undefined)
                that.selectionChanged(that, parentId, parentRelId, ids);
        })
            .on("rowDoubleClicked", (event, parentId, parentRelId, id) => {
            event.stopPropagation();
            that.rowDoubleClicked(that, id);
        })
            .on("tabCreated", () => {
            that.resizeControls();
        })
            .on("tabSelected", (event, parentId, parentRelId, isPropertyTab) => {
            //that.m_$tabs.synTabs("clearSelection");
            that.m_relId = parentRelId;
        })
            .synTabs({
            windowName: "processmaprelationframe",
            propertyPageMode: Base_1.PropertyPageMode.View,
            parentContext: {
                parentId: undefined
            },
            viewName: that.m_viewName
        });
        $("#processMapPane").on("diagramChanged", () => {
            if (that.m_readonly !== true && that.diagramHasChanged()) {
                that.m_diagramChanged = true;
                that.askSaveChanges(false, (saveResult) => {
                    if (saveResult === m.ViewSaveResult.Save && !that.m_saveInProgress) {
                        that.m_$container.trigger("controlLogFullLicense");
                        that.m_saveInProgress = true;
                        Utilities_1.synUtil.beginAjaxProgress(".changeBar .btn.save");
                        if (that.m_viewMode === ViewMode.ProcessView) {
                            if (that.checkProcessDiagramIsValid(that.saveDiagramToSynerisDiagram())) {
                                that.syncProcess(true).then(() => {
                                    that.updateToggleButton();
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("processmap.savesuccessful"));
                                    that.m_saveInProgress = false;
                                    that.disableUI(false);
                                    Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                                    that.m_diagramChanged = false;
                                }).catch(() => {
                                    if (that.m_layoutSaveFailed === false) {
                                        alert(Utilities_1.synUtil.Strings.getValue("processmap.saveerroroktoreload"));
                                        window.location.reload();
                                    }
                                    else {
                                        Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("processmap.saveerrortryagain"));
                                        that.m_saveInProgress = false;
                                        that.disableUI(false);
                                        Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                                    }
                                });
                            }
                            else {
                                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("processmap.invalidprocess"));
                                that.m_saveInProgress = false;
                                Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                            }
                        }
                        else if (that.m_viewMode === ViewMode.StepsView) {
                            if (that.checkStepsDiagramIsValid(that.saveDiagramToSynerisDiagram())) {
                                that.syncSteps(true).then(() => {
                                    that.updateToggleButton();
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("processmap.savesuccessful"));
                                    that.m_saveInProgress = false;
                                    that.disableUI(false);
                                    Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                                    that.m_diagramChanged = false;
                                }).catch(() => {
                                    if (that.m_layoutSaveFailed === false) {
                                        alert(Utilities_1.synUtil.Strings.getValue("processmap.saveerroroktoreload"));
                                        window.location.reload();
                                    }
                                    else {
                                        Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("processmap.saveerrortryagain"));
                                        that.m_saveInProgress = false;
                                        that.disableUI(false);
                                        Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                                    }
                                });
                            }
                            else {
                                that.m_saveInProgress = false;
                                Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                            }
                        }
                    }
                    else if (saveResult === m.ViewSaveResult.Cancel) {
                        $.address.parameter("readonly", "true", false);
                        that.m_resetInstance = true;
                        that.setInstanceAsync().then(() => {
                            that.disableUI(false);
                        });
                    }
                });
            }
            else {
                that.m_diagramChanged = false;
                that.disableUI(false);
            }
        });
    }
    disableUI(disable = true) {
        super.disableUI(disable);
        if (disable === true) {
            $("#toggleEditButton").css("visibility", "hidden");
            $("#buttonContainer > #navigation").css("visibility", "hidden");
        }
        else {
            $("#toggleEditButton").css("visibility", "visible");
            $("#buttonContainer > #navigation").css("visibility", "visible");
        }
    }
    //#endregion Inherited from SynView
    //#region Helpers
    // Set the instance
    setInstanceAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let id = that.m_id;
            if (that.m_id !== that.m_lastFetchId || that.m_resetInstance === true) {
                that.m_lastFetchId = that.m_id;
                that.m_resetInstance = false;
                if (id && id.split("|").length === 3 && (id.split("|")[2] === that.m_typeIdProcessMap || id.split("|")[2] === that.m_typeIdProcess || id.split("|")[2] === that.m_typeIdProcessStep)) {
                    // Diagram view
                    $("#containerDiagram").show();
                    $("#containerSearch").hide();
                    let splitId = id.split("|");
                    that.m_typeId = splitId[2];
                    Utilities_1.synUtil.beginAjaxProgress();
                    // Update toggleEdit button
                    let $toggleEditButton = $("#toggleEditButton");
                    if ($toggleEditButton) {
                        if ($.address.parameter("readonly") !== "true") {
                            $toggleEditButton
                                .attr("title", Utilities_1.synUtil.Strings.getValue("processmap.view"))
                                .html("<i class='fa fa-eye'>");
                        }
                        else {
                            $toggleEditButton
                                .attr("title", Utilities_1.synUtil.Strings.getValue("processmap.edit"))
                                .html("<i class='fa fa-pencil'>");
                        }
                    }
                    // Get instance data
                    that.m_instance = yield Utilities_1.synUtil.getInstanceAsync(id);
                    // Set relation tabs
                    that.setRelationInstance(id);
                    // Set readonly based on URL parameter and permissions
                    const hasPermission = yield CheckSecurity_1.synCheckSecurity.checkSecurityInstance(id, [CheckSecurity_1.synRights.ChangeProp]);
                    that.m_readonly = ($.address.parameter("readonly") === "true") || !hasPermission;
                    // Hide edit toggle button if no permission
                    if (hasPermission)
                        $("#toggleEditButton").show();
                    else
                        $("#toggleEditButton").hide();
                    // Only show search field if readonly is true
                    if (that.m_readonly === true) {
                        $("#searchContainer")
                            .show()
                            .off("keyup")
                            .on("keyup", (e) => {
                            if (e.which === 13)
                                $("#searchButton").trigger("click");
                        });
                        let $searchButton = $("#searchButton");
                        $searchButton.off("click").on("click", (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            Utilities_1.synUtil.beginAjaxProgress($searchButton);
                            let $searchInput = $("#searchContainer > input");
                            let windowData = Utilities_1.synUtil.popupWindow({
                                width: 600,
                                height: 400,
                                modal: false
                            });
                            if (windowData.contentDiv.synList("isInitialized")) {
                                windowData.contentDiv.synList("destroy");
                                windowData.contentDiv.html("");
                            }
                            let $window = $("#" + windowData.windowID).parent();
                            $window.hide();
                            yield windowData.contentDiv
                                .on("selectionChanged", () => {
                                that.updateSelectionContext();
                            })
                                .on("fetchedIds", (_evt, ids) => {
                                if (!ids.length) {
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("searchnoresults"));
                                    $("#" + windowData.windowID).data("kendoWindow").close();
                                }
                                else
                                    $window.show();
                            })
                                .synList({
                                columnOptions: {
                                    layoutName: "cceparalistctrl_doctype",
                                    catIdDependent: true,
                                    catId: parseInt(that.m_typeIdProcess),
                                },
                                dataItemGenerator: (ctx) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    let searchTypeIds = Utilities_1.synUtil.Configs.getValueMandatory("processmap.searchtypeids");
                                    let searchTypeIdsSplit = Utilities_1.synUtil.splitWithoutEmptyEntries(searchTypeIds, "|");
                                    const allPromises = [];
                                    // --- for now only run the first search and immediately set the result, might change in the future (synList doesn't support more than one result per default)
                                    for (let search of searchTypeIdsSplit) {
                                        allPromises.push(new Promise((resolve) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                            let searchTypeId = search.split(":")[0];
                                            let dependants = search.split(":")[1];
                                            let fieldToSearch = Utilities_1.synUtil.Configs.getValue("processmap.searchfield", "cgdocument.doclabel", parseInt(searchTypeId));
                                            let processMapPathField = Utilities_1.synUtil.Configs.getValueMandatory("processmap.processmappathfield", parseInt(searchTypeId));
                                            let searchData = {
                                                "cgdocument.typeid": searchTypeId,
                                            };
                                            searchData[fieldToSearch] = $searchInput.val().toString();
                                            searchData[processMapPathField] = that.m_id.split('|')[1];
                                            if (dependants === "Y")
                                                searchData["cgexplorer.childs"] = "Y";
                                            let searchInstance = yield Instance_1.Instance.fromSearchData(searchData);
                                            Utilities_1.synUtil.getAJAXData({
                                                method: "POST",
                                                url: Utilities_1.synUtil.getWSUrl("Search"),
                                                requestData: { query: JSON.stringify(searchInstance.toJSON()) },
                                                done(resultsId, _textStatus, _jqXHR, handlerKey) {
                                                    Utilities_1.synUtil.getAJAXData({
                                                        method: "POST",
                                                        url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                                                        headers: { "X-WS-Affinity": handlerKey },
                                                        requestData: {
                                                            oneShot: "true",
                                                        },
                                                        done: (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                            const results = yield Instance_1.Instance.fromJSONArray(data.data);
                                                            if (data.moreRowsAvailable)
                                                                Utilities_1.synUtil.Notifications.info(Utilities_1.synUtil.Strings.getValue("qrymoreresultsavailablet"));
                                                            resolve(List_1.instancesToListDataItems(results));
                                                        })
                                                    });
                                                }
                                            });
                                        })));
                                    }
                                    yield Promise.all(allPromises);
                                    let results = [];
                                    allPromises.forEach((promise) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                        results = results.concat(yield promise);
                                    }));
                                    return results;
                                })
                            });
                            Utilities_1.synUtil.endAjaxProgress($searchButton);
                        }));
                    }
                    else
                        $("#searchContainer").hide();
                    // Set diagram
                    if (that.m_instance.items["ceproclk.layout"].value)
                        that.m_diagramToLoad = JSON.parse(that.m_instance.items["ceproclk.layout"].valueAsString);
                    else {
                        that.m_diagramToLoad = {
                            processNodes: [],
                            designNodes: [],
                            stepNodes: [],
                            connectors: [],
                        };
                    }
                    let childFieldNames = ["id", "cgdocument.doclabel", "cgdocstructure.structuretype"];
                    Utilities_1.synUtil.getAJAXData({
                        url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + id + "/1",
                        requestData: {},
                        done(resultsId, textStatus, jqXHR, handlerKey) {
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                                requestData: {
                                    fieldNames: JSON.stringify(childFieldNames),
                                    oneShot: "true",
                                },
                                done: (childrenJson) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    const children = yield Instance_1.Instance.fromJSONArray(childrenJson.data);
                                    if (that.m_typeId === that.m_typeIdProcessMap) {
                                        that.m_viewMode = ViewMode.ProcessView;
                                        that.createNavigation().then(() => {
                                            if (!that.m_readonly) {
                                                let processChildren = [];
                                                for (let child of children) {
                                                    if (that.hasValidRelid(that.m_instance, child) && child.items["cgdocument.typeid"].valueToString() === that.m_typeIdProcess)
                                                        processChildren.push(child);
                                                }
                                                that.syncProcess(false).then(() => {
                                                    that.loadDiagram();
                                                    Utilities_1.synUtil.endAjaxProgress();
                                                    that.m_fullInitDone = true;
                                                });
                                            }
                                            else {
                                                that.loadDiagram();
                                                Utilities_1.synUtil.endAjaxProgress();
                                                that.m_fullInitDone = true;
                                            }
                                        });
                                    }
                                    else if (that.m_typeId === that.m_typeIdProcess) {
                                        // Find out current ViewMode (Subprocesses or steps), throw error on mixed children types
                                        if (children.length === 0)
                                            that.m_viewMode = ViewMode.ProcessView;
                                        else {
                                            let childrenTypeId;
                                            for (let child of children) {
                                                let childTypeId = child.items["cgdocument.typeid"].valueToString();
                                                if ((childTypeId === that.m_typeIdProcess || childTypeId === that.m_typeIdProcessStep) && that.hasValidRelid(that.m_instance, child)) {
                                                    if (childrenTypeId == undefined)
                                                        childrenTypeId = childTypeId;
                                                    else if (childrenTypeId !== childTypeId) {
                                                        Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("processmap.mixedchildren"));
                                                        $.error("Mixed subprocesses with processsteps.");
                                                    }
                                                }
                                            }
                                            if (childrenTypeId == undefined || childrenTypeId === that.m_typeIdProcess)
                                                that.m_viewMode = ViewMode.ProcessView;
                                            else
                                                that.m_viewMode = ViewMode.StepsView;
                                        }
                                        that.createNavigation().then(() => {
                                            if (that.m_viewMode === ViewMode.ProcessView) {
                                                if (!that.m_readonly) {
                                                    let processChildren = [];
                                                    for (let child of children) {
                                                        if (that.hasValidRelid(that.m_instance, child) && child.items["cgdocument.typeid"].valueToString() === that.m_typeIdProcess)
                                                            processChildren.push(child);
                                                    }
                                                    that.syncProcess(false).then(() => {
                                                        that.loadDiagram();
                                                        Utilities_1.synUtil.endAjaxProgress();
                                                        that.m_fullInitDone = true;
                                                    });
                                                }
                                                else {
                                                    that.loadDiagram();
                                                    Utilities_1.synUtil.endAjaxProgress();
                                                    that.m_fullInitDone = true;
                                                }
                                            }
                                            else {
                                                if (!that.m_readonly) {
                                                    let stepsChildren = [];
                                                    for (let child of children) {
                                                        if (that.hasValidRelid(that.m_instance, child) && child.items["cgdocument.typeid"].valueToString() === that.m_typeIdProcessStep)
                                                            stepsChildren.push(child);
                                                    }
                                                    that.syncSteps(false).then(() => {
                                                        that.loadDiagram();
                                                        Utilities_1.synUtil.endAjaxProgress();
                                                        that.m_fullInitDone = true;
                                                    });
                                                }
                                                else {
                                                    that.loadDiagram();
                                                    Utilities_1.synUtil.endAjaxProgress();
                                                    that.m_fullInitDone = true;
                                                }
                                            }
                                        });
                                    }
                                    else {
                                        // User should never see this message
                                        Utilities_1.synUtil.Notifications.error("Invalid typeid, must either be processmap or process.");
                                        $.error("Invalid typeid!");
                                    }
                                }),
                            });
                        }
                    });
                }
                else {
                    // Processmaps overview
                    let defaultProcessmapFieldName = Utilities_1.synUtil.Configs.getValue("processmap.userdefaultprocessmapdocidfield", "");
                    let defaultProcessMapDocid;
                    let instanceId;
                    if (defaultProcessmapFieldName) {
                        let userInfo = Utilities_1.synUtil.UserInfo.getUserInfo();
                        defaultProcessMapDocid = userInfo["Fields"][defaultProcessmapFieldName];
                        instanceId = userInfo["Fields"]["ceuser.instanzid"];
                    }
                    if (defaultProcessMapDocid && defaultProcessMapDocid !== "" && that.m_fullInitDone === false) {
                        let url = "#/processmap?id=" + instanceId + "|" + defaultProcessMapDocid + "|" + that.m_typeIdProcessMap;
                        if ($.address.parameter("readonly"))
                            url += "&readonly=" + $.address.parameter("readonly");
                        else
                            url += "&readonly=true";
                        window.location.replace(url);
                    }
                    else {
                        // Search all processmaps
                        Utilities_1.synUtil.beginAjaxProgress();
                        const processMaps = yield Utilities_1.synUtil.searchAsync(parseInt(that.m_typeIdProcessMap, 10), undefined, ["id", "cgdocument.doclabel"]);
                        Utilities_1.synUtil.endAjaxProgress();
                        if (processMaps.length === 1) {
                            that.m_SingleProcessMapMode = true;
                            let url = "#/processmap?id=" + processMaps[0]["id"].valueAsString;
                            if ($.address.parameter("readonly"))
                                url += "&readonly=" + $.address.parameter("readonly");
                            else
                                url += "&readonly=true";
                            window.location.replace(url);
                        }
                        else {
                            that.m_SingleProcessMapMode = false;
                            if (that.m_$searchList.synList("isInitialized"))
                                that.m_$searchList.synList("destroy");
                            yield that.m_$searchList
                                .on("fetchedIds", (_evt, ids) => {
                                $("#containerDiagram").hide();
                                $("#containerSearch").show();
                                if (!ids.length)
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("searchnoresults"));
                            })
                                .on("selectionChanged", (_evt, ids) => {
                                that.updateSelectionContext();
                                if (ids && ids.length >= 1)
                                    that.setRelationInstance(ids[0]);
                                else
                                    that.setRelationInstance(undefined);
                                if (ids && ids.length === 1) {
                                    $("#searchGoToProcessmap")
                                        .removeClass("k-state-disabled")
                                        .removeAttr("disabled")
                                        .off("click")
                                        .on("click", () => {
                                        let url = "#/processmap?id=" + ids[0];
                                        if ($.address.parameter("readonly"))
                                            url += "&readonly=" + $.address.parameter("readonly");
                                        else
                                            url += "&readonly=true";
                                        window.location.replace(url);
                                    });
                                }
                                else {
                                    $("#searchGoToProcessmap")
                                        .off("click")
                                        .addClass("k-state-disabled")
                                        .attr("disabled", "disabled");
                                }
                            })
                                .on("rowDoubleClicked", () => {
                                $("#searchGoToProcessmap").trigger("click");
                            })
                                .synList({
                                columnOptions: {
                                    layoutName: "cceparalistctrl_doctype",
                                    catIdDependent: true,
                                    catId: parseInt(that.m_typeIdProcessMap),
                                },
                                raiseBeforeSelectionChanged: false,
                                doubleClickAction: false,
                                dataItemGenerator: (ctx) => Promise.resolve(List_1.instancesToListDataItems(processMaps))
                            });
                        }
                    }
                }
            }
        });
    }
    // Create and add ports for node.
    static getPorts() {
        let ports = [
            { id: "portNW", shape: "Circle", offset: { x: 0, y: 0.0 } },
            { id: "portN", shape: "Circle", offset: { x: .5, y: 0 } },
            { id: "portNE", shape: "Circle", offset: { x: 1, y: 0 } },
            { id: "portE", shape: "Circle", offset: { x: 1, y: .5 } },
            { id: "portSE", shape: "Circle", offset: { x: 1, y: 1 } },
            { id: "portS", shape: "Circle", offset: { x: 0.5, y: 1 } },
            { id: "portSW", shape: "Circle", offset: { x: 0, y: 1 } },
            { id: "portW", shape: "Circle", offset: { x: 0, y: 0.5 } },
        ];
        return ports;
    }
    // Sets the default values of a node
    getNodeDefaults(obj) {
        if (obj.width == undefined)
            obj.width = 100;
        if (obj.height == undefined)
            obj.height = 100;
        if (!obj.style)
            obj.style = { fill: "#fff", strokeColor: "#245c86" };
        if (!obj.style.fill)
            obj.style.fill = "#fff";
        if (!obj.style.strokeColor)
            obj.style.strokeColor = "#245c86";
        // Set ports
        obj.ports = processmap.getPorts();
        return obj;
    }
    // Sets the default values of a connector
    getConnectorDefaults(obj) {
        if (obj.type == undefined)
            obj.type = "Orthogonal";
        if (obj.targetDecorator == undefined)
            obj.targetDecorator = { shape: "Arrow", width: 10, height: 10 };
        return obj;
    }
    // Sets the Node style for DragEnter element.
    dragEnter(args) {
        let that = this;
        let obj = args.element;
        if (obj instanceof ej2_diagrams_1.Node) {
            let oWidth = obj.width;
            let oHeight = obj.height;
            let ratio = 100 / obj.width;
            obj.width = 100;
            obj.height *= ratio;
            obj.offsetX += (obj.width - oWidth) / 2;
            obj.offsetY += (obj.height - oHeight) / 2;
            obj.style = {
                fill: obj.style.fill === "none" ? "none" : $("#colorPickerFill").data("kendoColorPicker").value(),
                strokeColor: obj.style.strokeColor === "none" ? "none" : "#245c86",
            };
            obj.annotations[0].style.fontSize = $("#fontSizeInput").val().toString() !== "" ? parseInt($("#fontSizeInput").val().toString()) : 12;
            obj.annotations[0].style.bold = $("#boldToggle").prop("checked");
            if (obj.data.isDesignShape === true && obj.data.shapeId !== DesignShapeId[DesignShapeId.Text])
                document.getElementById("processMapDiagram").ej2_instances[0].setActiveLayer("designLayer");
            else
                document.getElementById("processMapDiagram").ej2_instances[0].setActiveLayer("documentLayer");
        }
    }
    getSymbolDefaults(symbol) {
        if (symbol.id === StepShapeId[StepShapeId.StepStartEnd]) {
            symbol.width = 80;
            symbol.height = 40;
        }
        else if (symbol.id === StepShapeId[StepShapeId.StepDecision] || symbol.id === ProcessShapeId[ProcessShapeId.ProcessSub]) {
            symbol.width = 50;
            symbol.height = 40;
        }
        else {
            symbol.width = 50;
            symbol.height = 50;
        }
    }
    getSymbolInfo(symbol) {
        return { fit: true };
    }
    updateSelection() {
        let that = this;
        let selectedNodes = that.m_diagram.selectedItems.nodes;
        let selectedConnectors = that.m_diagram.selectedItems.connectors;
        let $copyStyleBtn = $("#copyStyleButton");
        let $pasteStyleBtn = $("#pasteStyleButton");
        let $removeBtn = $("#removeButton");
        if (selectedNodes.length >= 1) {
            $removeBtn.removeAttr("disabled").removeClass("k-state-disabled");
            // Update shape selection
            $("#shapeSelection").children().remove();
            if (that.m_viewMode === ViewMode.ProcessView) {
                let selectionHasProcessShapes = false;
                let selectionHasDesignShapes = false;
                let selectionHasTextShapes = false;
                for (let node of selectedNodes) {
                    if (node.data) {
                        if (node.data["isDesignShape"] === true) {
                            selectionHasDesignShapes = true;
                            if (node.data["shapeId"] === DesignShapeId[DesignShapeId.Text])
                                selectionHasTextShapes = true;
                        }
                        else
                            selectionHasProcessShapes = true;
                    }
                }
                // Check for mixed shapes
                let shapeId = selectedNodes[0].data["shapeId"];
                for (let node of selectedNodes) {
                    if (node.data["shapeId"] !== shapeId) {
                        shapeId = "";
                        break;
                    }
                }
                // Add mixed option entry if mixed
                if (shapeId === "")
                    $("#shapeSelection").append("<option id=''></option>");
                if (selectionHasTextShapes || (selectionHasProcessShapes && selectionHasDesignShapes) || (!selectionHasProcessShapes && !selectionHasDesignShapes)) {
                    $("#shapeSelection").attr("disabled", "disabled");
                }
                else if (selectionHasProcessShapes) {
                    for (let shape of that.m_processShapes)
                        $("#shapeSelection").append("<option id='" + shape.id + "'>" + shape.id + "</option>");
                    // Select actual shape if not mixed
                    if (shapeId !== "")
                        $("#shapeSelection").val(shapeId);
                    $("#shapeSelection").removeAttr("disabled");
                }
                else if (selectionHasDesignShapes) {
                    for (let shape of that.m_designShapes) {
                        if (shape.data["shapeId"] !== DesignShapeId[DesignShapeId.Text])
                            $("#shapeSelection").append("<option id='" + shape.id + "'>" + shape.id + "</option>");
                    }
                    // Select actual shape if not mixed
                    if (shapeId !== "")
                        $("#shapeSelection").val(shapeId);
                    $("#shapeSelection").removeAttr("disabled");
                }
            }
            else if (that.m_viewMode === ViewMode.StepsView) {
                // Check for mixed shapes
                let shapeId = selectedNodes[0].data["shapeId"];
                for (let node of selectedNodes) {
                    if (node.data["shapeId"] !== shapeId) {
                        shapeId = "";
                        break;
                    }
                }
                // Add mixed option entry if mixed
                if (shapeId === "")
                    $("#shapeSelection").append("<option id=''></option>");
                for (let shape of that.m_stepsShapes)
                    $("#shapeSelection").append("<option id='" + shape.id + "'>" + shape.id + "</option>");
                // Select actual shape if not mixed
                if (shapeId !== "")
                    $("#shapeSelection").val(shapeId);
                $("#shapeSelection").removeAttr("disabled");
            }
            // Update fill color selection
            let shapeColor = selectedNodes[0].style.fill;
            for (let node of selectedNodes) {
                if (node.style.fill !== shapeColor)
                    shapeColor = "";
            }
            if (shapeColor === "" || shapeColor === "none") {
                let color = kendo.parseColor("#fff", true);
                that.m_colorPickerFill.color(color);
            }
            else {
                let color = kendo.parseColor(shapeColor, true);
                that.m_colorPickerFill.color(color);
            }
            // Update style buttons
            if (selectedNodes.length === 1)
                $copyStyleBtn.removeAttr("disabled").removeClass("k-state-disabled");
            else
                $copyStyleBtn.attr("disabled", "disabled").addClass("k-state-disabled");
            if (that.m_copiedDiagramNodeStyle != undefined)
                $pasteStyleBtn.removeAttr("disabled").removeClass("k-state-disabled");
            // Update goToChild navigation and relation tabs
            let ids = [];
            for (let node of selectedNodes) {
                if (node.data && node.data["id"])
                    ids.push(node.data["id"]);
            }
            if (selectedNodes.length === 1 && ids.length === 1) {
                that.setRelationInstance(ids[0]);
                // Only enable navigation if selected node is not process step
                if (ids[0].split("|")[2] !== that.m_typeIdProcessStep) {
                    $("#goToChild")
                        .removeClass("k-state-disabled")
                        .removeAttr("disabled")
                        .attr("title", selectedNodes[0].annotations[0].content)
                        .off("click")
                        .on("click", () => {
                        let url = "#/processmap?id=" + ids[0];
                        if ($.address.parameter("readonly"))
                            url += "&readonly=" + $.address.parameter("readonly");
                        window.location.replace(url);
                    });
                }
                else {
                    $("#goToChild")
                        .off("click")
                        .addClass("k-state-disabled")
                        .attr("disabled", "disabled")
                        .removeAttr("title");
                }
            }
            else {
                that.setRelationInstance(that.m_id);
                $("#goToChild")
                    .off("click")
                    .addClass("k-state-disabled")
                    .attr("disabled", "disabled")
                    .removeAttr("title");
            }
            //that.SelectionContext.setSelectionContext({ selectedIds: ids ? ids : [], parentControl: true, normalParentContext: { parentId: that.m_id, parentRelId: SpecialRelIds.All }, parentControlParentContext: { parentId: ids[0], parentRelId: SpecialRelIds.All } });
            that.MainMenu.synMenu("revalidate");
        }
        else {
            $removeBtn.attr("disabled", "disabled").addClass("k-state-disabled");
            $("#shapeSelection").attr("disabled", "disabled");
            $("#shapeSelection").children().remove();
            // set current active Node as Selection Context
            //that.SelectionContext.setSelectionContext({ selectedIds: [that.m_id], parentControl: false, normalParentContext: { parentId: that.m_id, parentRelId: that.m_relId } });
            that.MainMenu.synMenu("revalidate");
            // Update style buttons
            $copyStyleBtn.attr("disabled", "disabled").addClass("k-state-disabled");
            $pasteStyleBtn.attr("disabled", "disabled").addClass("k-state-disabled");
            // Disable goToChild navigation
            $("#goToChild")
                .off("click")
                .addClass("k-state-disabled")
                .attr("disabled", "disabled")
                .removeAttr("title");
            // Set relation tabs
            that.setRelationInstance(that.m_id);
        }
        // Update text color selection (Works for nodes and connectors)
        let textColor = "";
        if (selectedNodes.length > 0)
            textColor = selectedNodes[0].annotations[0].style.color;
        else if (selectedConnectors.length > 0)
            textColor = selectedConnectors[0].annotations[0].style.color;
        for (let node of selectedNodes) {
            if (node.annotations[0].style.color !== textColor)
                textColor = "";
        }
        for (let connector of selectedConnectors) {
            if (connector.annotations[0].style.color !== textColor)
                textColor = "";
        }
        if (textColor === "") {
            let color = kendo.parseColor("#fff", true);
            that.m_colorPickerText.color(color);
        }
        else {
            let color = kendo.parseColor(textColor, true);
            that.m_colorPickerText.color(color);
        }
        // Update bold toggle
        let boldToggle;
        for (let node of selectedNodes) {
            if (node.annotations[0].style.bold === true && (boldToggle == undefined || boldToggle === true))
                boldToggle = true;
            else
                boldToggle = false;
        }
        for (let connector of selectedConnectors) {
            if (connector.annotations[0].style.bold === true && (boldToggle == undefined || boldToggle === true))
                boldToggle = true;
            else
                boldToggle = false;
        }
        if (boldToggle == undefined)
            boldToggle = false;
        $("#boldToggle").prop("checked", boldToggle);
        // Update fontSize input (Works for nodes and connectors)
        let $fontSizeInput = $("#fontSizeInput");
        let $fontSizeBtnUp = $("#fontSizeUp");
        let $fontSizeBtnDown = $("#fontSizeDown");
        if (selectedNodes.length + selectedConnectors.length === 1) {
            $fontSizeBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $fontSizeBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let currentFontSize;
            if (selectedNodes.length === 1)
                currentFontSize = selectedNodes[0].annotations[0].style.fontSize;
            if (selectedConnectors.length === 1)
                currentFontSize = selectedConnectors[0].annotations[0].style.fontSize;
            $fontSizeInput.val(currentFontSize);
        }
        else if (selectedNodes.length + selectedConnectors.length > 1) {
            $fontSizeBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $fontSizeBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let commonFontSize;
            for (let node of selectedNodes) {
                if (commonFontSize == undefined)
                    commonFontSize = node.annotations[0].style.fontSize;
                else {
                    if (commonFontSize !== node.annotations[0].style.fontSize) {
                        commonFontSize = "";
                        break;
                    }
                }
            }
            for (let connector of selectedConnectors) {
                if (commonFontSize == undefined)
                    commonFontSize = connector.annotations[0].style.fontSize;
                else {
                    if (commonFontSize !== connector.annotations[0].style.fontSize) {
                        commonFontSize = "";
                        break;
                    }
                }
            }
            $fontSizeInput.val(commonFontSize);
        }
        else {
            $fontSizeInput.val("");
            $fontSizeBtnUp.attr("disabled", "disabled").addClass("k-state-disabled");
            $fontSizeBtnDown.attr("disabled", "disabled").addClass("k-state-disabled");
        }
        // Update posX input (Only works for nodes)
        let $posXInput = $("#positionXInput");
        let $posXBtnUp = $("#positionXUp");
        let $posXBtnDown = $("#positionXDown");
        if (selectedNodes.length === 1) {
            $posXBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $posXBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let currentPosX;
            if (selectedNodes.length === 1)
                currentPosX = selectedNodes[0].offsetX;
            $posXInput.val(parseInt(currentPosX));
        }
        else if (selectedNodes.length > 1) {
            $posXBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $posXBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let commonPosX;
            for (let node of selectedNodes) {
                if (commonPosX == undefined)
                    commonPosX = node.offsetX;
                else {
                    if (commonPosX !== node.offsetX) {
                        commonPosX = "";
                        break;
                    }
                }
            }
            if (commonPosX === "") {
                $posXInput.val("");
                $posXBtnUp.attr("disabled", "disabled").addClass("k-state-disabled");
                $posXBtnDown.attr("disabled", "disabled").addClass("k-state-disabled");
            }
            else
                $posXInput.val(commonPosX);
        }
        else {
            $posXInput.val("");
            $posXBtnUp.attr("disabled", "disabled").addClass("k-state-disabled");
            $posXBtnDown.attr("disabled", "disabled").addClass("k-state-disabled");
        }
        // Update posY input (Only works for nodes)
        let $posYInput = $("#positionYInput");
        let $posYBtnUp = $("#positionYUp");
        let $posYBtnDown = $("#positionYDown");
        if (selectedNodes.length === 1) {
            $posYBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $posYBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let currentPosY;
            if (selectedNodes.length === 1)
                currentPosY = selectedNodes[0].offsetY;
            $posYInput.val(parseInt(currentPosY));
        }
        else if (selectedNodes.length > 1) {
            $posYBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $posYBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let commonPosY;
            for (let node of selectedNodes) {
                if (commonPosY == undefined)
                    commonPosY = node.offsetY;
                else {
                    if (commonPosY !== node.offsetY) {
                        commonPosY = "";
                        break;
                    }
                }
            }
            if (commonPosY === "") {
                $posYInput.val("");
                $posYBtnUp.attr("disabled", "disabled").addClass("k-state-disabled");
                $posYBtnDown.attr("disabled", "disabled").addClass("k-state-disabled");
            }
            else
                $posYInput.val(commonPosY);
        }
        else {
            $posYInput.val("");
            $posYBtnUp.attr("disabled", "disabled").addClass("k-state-disabled");
            $posYBtnDown.attr("disabled", "disabled").addClass("k-state-disabled");
        }
        // Update width input (Only works for nodes)
        let $widthInput = $("#widthInput");
        let $widthBtnUp = $("#widthUp");
        let $widthBtnDown = $("#widthDown");
        if (selectedNodes.length === 1) {
            $widthBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $widthBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let currentWidth;
            if (selectedNodes.length === 1)
                currentWidth = selectedNodes[0].width;
            $widthInput.val(parseInt(currentWidth));
        }
        else if (selectedNodes.length > 1) {
            $widthBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $widthBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let commonWidth;
            for (let node of selectedNodes) {
                if (commonWidth == undefined)
                    commonWidth = node.width;
                else {
                    if (commonWidth !== node.width) {
                        commonWidth = "";
                        break;
                    }
                }
            }
            if (commonWidth === "") {
                $widthInput.val("");
                $widthBtnUp.attr("disabled", "disabled").addClass("k-state-disabled");
                $widthBtnDown.attr("disabled", "disabled").addClass("k-state-disabled");
            }
            else
                $widthInput.val(commonWidth);
        }
        else {
            $widthInput.val("");
            $widthBtnUp.attr("disabled", "disabled").addClass("k-state-disabled");
            $widthBtnDown.attr("disabled", "disabled").addClass("k-state-disabled");
        }
        // Update height input (Only works for nodes)
        let $heightInput = $("#heightInput");
        let $heightBtnUp = $("#heightUp");
        let $heightBtnDown = $("#heightDown");
        if (selectedNodes.length === 1) {
            $heightBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $heightBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let currentHeight;
            if (selectedNodes.length === 1)
                currentHeight = selectedNodes[0].height;
            $heightInput.val(parseInt(currentHeight));
        }
        else if (selectedNodes.length > 1) {
            $heightBtnUp.removeAttr("disabled").removeClass("k-state-disabled");
            $heightBtnDown.removeAttr("disabled").removeClass("k-state-disabled");
            let commonHeight;
            for (let node of selectedNodes) {
                if (commonHeight == undefined)
                    commonHeight = node.height;
                else {
                    if (commonHeight !== node.height) {
                        commonHeight = "";
                        break;
                    }
                }
            }
            if (commonHeight === "") {
                $heightInput.val("");
                $heightBtnUp.attr("disabled", "disabled").addClass("k-state-disabled");
                $heightBtnDown.attr("disabled", "disabled").addClass("k-state-disabled");
            }
            else
                $heightInput.val(commonHeight);
        }
        else {
            $heightInput.val("");
            $heightBtnUp.attr("disabled", "disabled").addClass("k-state-disabled");
            $heightBtnDown.attr("disabled", "disabled").addClass("k-state-disabled");
        }
        // Update layout buttons
        if (selectedNodes.length < 2) {
            $("#alignHorizontalLeftButton").attr("disabled", "disabled").addClass("k-state-disabled");
            $("#alignHorizontalCenterButton").attr("disabled", "disabled").addClass("k-state-disabled");
            $("#alignHorizontalRightButton").attr("disabled", "disabled").addClass("k-state-disabled");
            $("#alignVerticalTopButton").attr("disabled", "disabled").addClass("k-state-disabled");
            $("#alignVerticalCenterButton").attr("disabled", "disabled").addClass("k-state-disabled");
            $("#alignVerticalBottomButton").attr("disabled", "disabled").addClass("k-state-disabled");
        }
        else {
            $("#alignHorizontalLeftButton").removeAttr("disabled").removeClass("k-state-disabled");
            $("#alignHorizontalCenterButton").removeAttr("disabled").removeClass("k-state-disabled");
            $("#alignHorizontalRightButton").removeAttr("disabled").removeClass("k-state-disabled");
            $("#alignVerticalTopButton").removeAttr("disabled").removeClass("k-state-disabled");
            $("#alignVerticalCenterButton").removeAttr("disabled").removeClass("k-state-disabled");
            $("#alignVerticalBottomButton").removeAttr("disabled").removeClass("k-state-disabled");
        }
        if (selectedNodes.length < 3) {
            $("#distributeHorizontalButton").attr("disabled", "disabled").addClass("k-state-disabled");
            $("#distributeVerticalButton").attr("disabled", "disabled").addClass("k-state-disabled");
        }
        else {
            $("#distributeHorizontalButton").removeAttr("disabled").removeClass("k-state-disabled");
            $("#distributeVerticalButton").removeAttr("disabled").removeClass("k-state-disabled");
        }
    }
    createPalette() {
        let that = this;
        $("#processMapPaletteContainer").empty().append('<div id="processMapPalette"></div>');
        let palettes;
        if (that.m_viewMode === ViewMode.ProcessView) {
            palettes = [
                { id: "processes", expanded: true, symbols: that.m_processShapes, iconCss: "e-ddb-icons e-flow", title: Utilities_1.synUtil.Strings.getValue("processmap.processshapes") },
                { id: "design", expanded: true, symbols: that.m_designShapes, iconCss: "e-ddb-icons e-flow", title: Utilities_1.synUtil.Strings.getValue("processmap.designshapes") },
            ];
        }
        else {
            palettes = [
                { id: "steps", expanded: true, symbols: that.m_stepsShapes, iconCss: "e-ddb-icons e-flow", title: Utilities_1.synUtil.Strings.getValue("processmap.stepsshapes") },
                { id: "connectors", expanded: true, symbols: that.m_connectors, iconCss: "e-ddb-icons e-connector", title: Utilities_1.synUtil.Strings.getValue("processmap.connectors") }
            ];
        }
        // Initializes the symbol palette
        let palette = new ej2_diagrams_1.SymbolPalette({
            expandMode: "Multiple", palettes,
            width: "100%", height: "100%", symbolHeight: 60, symbolWidth: 60,
            symbolMargin: { left: 15, right: 15, top: 15, bottom: 15 },
            getNodeDefaults: that.getSymbolDefaults,
            getSymbolInfo: that.getSymbolInfo,
            enableAnimation: false,
        });
        palette.appendTo("#processMapPalette");
        // Add "Aa" text to text shape
        $("#processMapPalette_container #Text_container")
            .css("text-align", "center")
            .css("line-height", "61px")
            .prepend("<span style='pointer-events: none;'>Aa</span>");
        $("#processMapPalette_container #Text_container canvas").css("display", "none");
    }
    createNavigation() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            // Go to parent for processmaps go to overview
            if (that.m_typeId === that.m_typeIdProcessMap) {
                if (that.m_SingleProcessMapMode === true) {
                    $("#goToParent")
                        .off("click")
                        .addClass("k-state-disabled")
                        .attr("disabled", "disabled")
                        .removeAttr("title");
                }
                else {
                    $("#goToParent")
                        .removeClass("k-state-disabled")
                        .removeAttr("disabled")
                        .attr("title", Utilities_1.synUtil.Strings.getValue("processmap.processmaps"))
                        .off("click")
                        .on("click", () => {
                        let url = "#/processmap";
                        if ($.address.parameter("readonly"))
                            url += "?readonly=" + $.address.parameter("readonly");
                        window.location.replace(url);
                    });
                }
            }
            else {
                // Get parents
                let fieldNames = ["id", "cgdocument.doclabel",];
                // Get parents process map
                let resultsIdProcessMap = yield Utilities_1.synUtil.getAJAXDataAsync({
                    url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + that.m_instance.id.value + "/-" + that.m_processMapRelIdProcesses,
                    requestData: {},
                });
                let parentsProcessMap = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("Results") + resultsIdProcessMap,
                    requestData: {
                        fieldNames: JSON.stringify(fieldNames),
                        oneShot: "true",
                    }
                });
                // Get parents processes (only if processRelIdProcesses is different from processMapRelIdProcesses)
                let parentsProcessTotal = 0;
                let parentsProcess;
                if (that.m_processMapRelIdProcesses !== that.m_processRelIdProcesses) {
                    let resultsIdProcess = yield Utilities_1.synUtil.getAJAXDataAsync({
                        url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + that.m_instance.id.value + "/-" + that.m_processRelIdProcesses,
                        requestData: {},
                    });
                    parentsProcess = yield Utilities_1.synUtil.getAJAXDataAsync({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("Results") + resultsIdProcess,
                        requestData: {
                            fieldNames: JSON.stringify(fieldNames),
                            oneShot: "true",
                        }
                    });
                    parentsProcessTotal = parentsProcess.total;
                }
                let numParents = parentsProcessMap.total + parentsProcessTotal;
                if (numParents > 1) {
                    // --- fa: Case should be handled. Maybe selection window on click?
                    Utilities_1.synUtil.Notifications.warning("Configuration error: Document has more than one parent!");
                    $("#goToParent")
                        .addClass("k-state-disabled")
                        .attr("disabled", "disabled")
                        .removeAttr("title");
                }
                else if (parentsProcessMap.total > 0) {
                    $("#goToParent")
                        .removeClass("k-state-disabled")
                        .removeAttr("disabled")
                        .attr("title", parentsProcessMap.data[0].items["cgdocument.doclabel"].valueAsString);
                    let parentId = parentsProcessMap.data[0].id.value;
                    $("#goToParent").off("click").on("click", () => {
                        $("#goToParent").removeAttr("title");
                        let url = "#/processmap?id=" + parentId;
                        if ($.address.parameter("readonly"))
                            url += "&readonly=" + $.address.parameter("readonly");
                        window.location.replace(url);
                    });
                }
                else if (parentsProcess.total > 0) {
                    $("#goToParent")
                        .removeClass("k-state-disabled")
                        .removeAttr("disabled")
                        .attr("title", parentsProcess.data[0].items["cgdocument.doclabel"].valueAsString);
                    let parentId = parentsProcess.data[0].id.value;
                    $("#goToParent").off("click").on("click", () => {
                        $("#goToParent").removeAttr("title");
                        let url = "#/processmap?id=" + parentId;
                        if ($.address.parameter("readonly"))
                            url += "&readonly=" + $.address.parameter("readonly");
                        window.location.replace(url);
                    });
                }
                else {
                    $("#goToParent")
                        .addClass("k-state-disabled")
                        .attr("disabled", "disabled")
                        .removeAttr("title");
                }
            }
            // Disable go to child, gets handled in updateSelection
            $("#goToChild")
                .addClass("k-state-disabled")
                .attr("disabled", "disabled")
                .removeAttr("title");
        });
    }
    createDiagram() {
        let that = this;
        $("#processMapDiagramContainer").empty().append('<div id="processMapDiagram"></div>');
        let gridlines = { lineColor: "#e0e0e0" };
        that.m_diagram = new ej2_diagrams_1.Diagram({
            width: "100%",
            height: "100%",
            selectedItems: that.m_readonly === true ? { constraints: ej2_diagrams_1.SelectorConstraints.None } : undefined,
            snapSettings: {
                constraints: ej2_diagrams_1.SnapConstraints.ShowLines | ej2_diagrams_1.SnapConstraints.SnapToLines,
                horizontalGridlines: gridlines,
                verticalGridlines: gridlines,
            },
            layers: [
                {
                    id: "designLayer",
                    visible: true,
                    objects: [],
                    lock: false,
                },
                {
                    id: "documentLayer",
                    visible: true,
                    objects: [],
                    lock: false,
                }
            ],
            // Sets the default values of a node
            getNodeDefaults: that.getNodeDefaults,
            // Sets the default values of a connector
            getConnectorDefaults: that.getConnectorDefaults,
            // Sets the Node style for DragEnter element.
            dragEnter: that.dragEnter,
            click: (e) => {
                that.m_colorPickerFill.close(); // Fix for IE11
                that.m_colorPickerText.close(); // Fix for IE11
                that.updateSelection();
            },
            doubleClick: (e) => {
                // Activate double click go to child for readonly mode
                if (that.m_readonly === true) {
                    $("#goToChild").trigger("click");
                }
            },
            drop: (e) => {
                that.updateSelection();
            },
            collectionChange: (e) => {
                that.updateToggleButton();
                // Check for duplicate syneris ids (Happens on copy & paste)
                let seenSynerisIds = [];
                for (let node of that.m_diagram.nodes) {
                    if (node.data && node.data["id"]) {
                        let synerisId = node.data["id"];
                        if (seenSynerisIds.indexOf(synerisId) !== -1)
                            node.data["id"] = undefined;
                        else
                            seenSynerisIds.push(synerisId);
                    }
                }
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            },
            positionChange: (e) => {
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            },
            propertyChange: (e) => {
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            },
            rotateChange: (e) => {
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            },
        });
        that.m_diagram.appendTo("#processMapDiagram");
        that.m_diagram.setActiveLayer("documentLayer");
        that.createPalette();
        $("#toggleEditButton").off("click").on("click", (e) => {
            let readonly = $.address.parameter("readonly");
            if (readonly !== "true")
                $.address.parameter("readonly", "true", false);
            else
                $.address.parameter("readonly", "false", false);
            that.m_resetInstance = true;
            that.getParametersFromUrl();
        });
        $("#printButton").off("click").on("click", (e) => {
            let options = {
                mode: "Data",
                region: "Content",
                multiplePage: false,
            };
            that.m_diagram.print(options);
        });
        $("#exportButton").off("click").on("click", (e) => {
            let options = {
                region: "Content",
                margin: { left: 10, right: 10, top: 10, bottom: 10 },
                format: "PNG",
            };
            that.m_diagram.exportDiagram(options);
        });
        // Toggle mode button
        $("#toggleModeButton").off("click").on("click", (e) => {
            if (that.m_viewMode === ViewMode.ProcessView)
                that.m_viewMode = ViewMode.StepsView;
            else
                that.m_viewMode = ViewMode.ProcessView;
            that.updateToggleButton();
            that.createPalette();
            that.updateSelection();
        });
        // Setup custom menu
        $("#docLabel").text(that.m_instance.items["cgdocument.doclabel"].valueAsString);
        $("#removeButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            for (let node of selectedItems)
                that.m_diagram.remove(node);
        });
        $("#undoButton").off("click").on("click", (e) => {
            let shapeBeforeUndo = that.m_diagram.nodes[0].data.shapeId;
            that.m_diagram.undo();
            that.updateSelection();
            if (!that.m_diagramChanged)
                $("#processMapPane").trigger("diagramChanged");
        });
        $("#redoButton").off("click").on("click", (e) => {
            that.m_diagram.redo();
            that.updateSelection();
            if (!that.m_diagramChanged)
                $("#processMapPane").trigger("diagramChanged");
        });
        $("#copyStyleButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            if (selectedItems.length === 1) {
                that.m_copiedDiagramNodeStyle = {
                    fillColor: selectedItems[0].style.fill,
                    fontSize: selectedItems[0].annotations[0].style.fontSize,
                    textColor: selectedItems[0].annotations[0].style.color,
                    bold: selectedItems[0].annotations[0].style.bold,
                };
                $("#pasteStyleButton").removeAttr("disabled").removeClass("k-state-disabled");
            }
        });
        $("#pasteStyleButton").off("click").on("click", (e) => {
            if (that.m_copiedDiagramNodeStyle != undefined) {
                let selectedItems = that.m_diagram.selectedItems.nodes.slice();
                for (let node of selectedItems) {
                    node.style.fill = that.m_copiedDiagramNodeStyle.fillColor;
                    node.annotations[0].style.fontSize = that.m_copiedDiagramNodeStyle.fontSize;
                    node.annotations[0].style.color = that.m_copiedDiagramNodeStyle.textColor;
                    node.style.strokeColor = that.m_copiedDiagramNodeStyle.textColor;
                    node.annotations[0].style.bold = that.m_copiedDiagramNodeStyle.bold;
                }
            }
        });
        $("#shapeSelection").change(() => {
            let shapeId = $("#shapeSelection").val();
            if (shapeId && shapeId !== "") {
                // Find out if designShape
                let isDesignShape = false;
                if (that.m_diagram.selectedItems.nodes[0].data["isDesignShape"] === true)
                    isDesignShape = true;
                // Get new shape
                let newShape;
                if (that.m_viewMode === ViewMode.ProcessView) {
                    if (isDesignShape)
                        newShape = that.m_designShapes.find(x => x.id === shapeId);
                    else
                        newShape = that.m_processShapes.find(x => x.id === shapeId);
                }
                else if (that.m_viewMode === ViewMode.StepsView)
                    newShape = that.m_stepsShapes.find(x => x.id === shapeId);
                // Set shape for all selected nodes and update shapeId data
                that.m_diagram.startGroupAction();
                for (let node of that.m_diagram.selectedItems.nodes) {
                    let oldDataHistory = JSON.parse(JSON.stringify(node.data));
                    let newDataHistory = JSON.parse(JSON.stringify(node.data));
                    newDataHistory["shapeId"] = shapeId;
                    let historyEntry = {
                        undoObject: { data: oldDataHistory },
                        redoObject: { data: newDataHistory }
                    };
                    that.m_diagram.historyManager.push(historyEntry);
                    node.data = newDataHistory;
                    node.shape = newShape.shape;
                    let offset = newShape.annotations[0].offset;
                    if (offset)
                        node.annotations[0].offset = offset;
                    else
                        node.annotations[0].offset = { x: 0.5, y: 0.5 };
                    that.m_diagram.dataBind();
                }
                that.m_diagram.endGroupAction();
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            }
        });
        $("#colorPickerContainerFill").empty().append('<input id="colorPickerFill" />');
        that.m_colorPickerFill = $("#colorPickerFill").kendoColorPicker({
            opacity: true,
            value: "#ffffff",
            buttons: false,
            select: (e) => {
                let selectedNodes = that.m_diagram.selectedItems.nodes;
                let changed = false;
                for (let node of selectedNodes) {
                    if (node.data["shapeId"] !== DesignShapeId[DesignShapeId.Text]) {
                        node.style.fill = e.value;
                        changed = true;
                    }
                }
                if (!that.m_diagramChanged && changed)
                    $("#processMapPane").trigger("diagramChanged");
            },
            open: () => {
                // Fix for cmdCopy/cmdPaste for colorPicker input field
                $("input.k-color-value").attr("type", "text");
                that.m_diagram.startGroupAction();
            },
            close: () => {
                that.m_diagram.dataBind();
                that.m_diagram.endGroupAction();
            },
        }).data("kendoColorPicker");
        // Set up/down fontSize, position and size buttons
        let holdIt = function (btn, action, timeout, speedup) {
            let originalTimeout = timeout;
            let timerHandle;
            let repeat = function () {
                action();
                timerHandle = window.setTimeout(repeat, timeout);
                if (timeout / speedup >= 50)
                    timeout = timeout / speedup;
                else
                    timeout = 50;
            };
            let start = function () {
                that.m_diagram.startGroupAction();
                repeat();
            };
            let stop = function () {
                window.clearTimeout(timerHandle);
                timeout = originalTimeout;
                that.m_diagram.endGroupAction();
            };
            btn.off("mousedown").on("mousedown", start);
            btn.off("mouseup").on("mouseup", stop);
        };
        let updateFontSize = function () {
            let newFontSize = $("#fontSizeInput").val().toString();
            if (newFontSize !== "") {
                for (let node of that.m_diagram.selectedItems.nodes) {
                    node.annotations[0].style.fontSize = parseInt(newFontSize);
                    that.m_diagram.dataBind();
                }
                for (let connector of that.m_diagram.selectedItems.connectors) {
                    connector.annotations[0].style.fontSize = parseInt(newFontSize);
                    that.m_diagram.dataBind();
                }
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            }
        };
        holdIt($("#fontSizeUp"), () => {
            let currentFontSizeString = $("#fontSizeInput").val().toString();
            let newFontSize;
            if (currentFontSizeString === "")
                newFontSize = 1;
            else
                newFontSize = parseInt(currentFontSizeString) + 1;
            $("#fontSizeInput").val(newFontSize);
            updateFontSize();
        }, 1000, 2);
        holdIt($("#fontSizeDown"), () => {
            let currentFontSizeString = $("#fontSizeInput").val().toString();
            let newFontSize;
            if (currentFontSizeString === "") {
                newFontSize = 1;
                $("#fontSizeInput").val(newFontSize);
                updateFontSize();
            }
            else if (parseInt(currentFontSizeString) > 1) {
                newFontSize = parseInt(currentFontSizeString) - 1;
                $("#fontSizeInput").val(newFontSize);
                updateFontSize();
            }
        }, 1000, 2);
        let updatePosX = function () {
            let newPosX = $("#positionXInput").val().toString();
            if (newPosX !== "") {
                for (let node of that.m_diagram.selectedItems.nodes) {
                    node.offsetX = parseInt(newPosX);
                    that.m_diagram.dataBind();
                }
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            }
        };
        holdIt($("#positionXUp"), () => {
            let currentPosXString = $("#positionXInput").val().toString();
            let newPosX;
            newPosX = parseInt(currentPosXString) + 1;
            $("#positionXInput").val(newPosX);
            updatePosX();
        }, 1000, 2);
        holdIt($("#positionXDown"), () => {
            let currentPosXString = $("#positionXInput").val().toString();
            let newPosX;
            newPosX = parseInt(currentPosXString) - 1;
            $("#positionXInput").val(newPosX);
            updatePosX();
        }, 1000, 2);
        let updatePosY = function () {
            let newPosY = $("#positionYInput").val().toString();
            if (newPosY !== "") {
                for (let node of that.m_diagram.selectedItems.nodes) {
                    node.offsetY = parseInt(newPosY);
                    that.m_diagram.dataBind();
                }
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            }
        };
        holdIt($("#positionYUp"), () => {
            let currentPosYString = $("#positionYInput").val().toString();
            let newPosY;
            newPosY = parseInt(currentPosYString) + 1;
            $("#positionYInput").val(newPosY);
            updatePosY();
        }, 1000, 2);
        holdIt($("#positionYDown"), () => {
            let currentPosYString = $("#positionYInput").val().toString();
            let newPosY;
            newPosY = parseInt(currentPosYString) - 1;
            $("#positionYInput").val(newPosY);
            updatePosY();
        }, 1000, 2);
        let updateWidth = function () {
            let newWidth = $("#widthInput").val().toString();
            if (newWidth !== "") {
                for (let node of that.m_diagram.selectedItems.nodes) {
                    if (that.m_keepAspectRatio) {
                        let ratio = node.height / node.width;
                        let diff = parseInt(newWidth) - node.width;
                        node.height = node.height + diff * ratio;
                    }
                    node.width = parseInt(newWidth);
                    that.m_diagram.dataBind();
                    if (that.m_keepAspectRatio)
                        that.updateSelection();
                }
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            }
        };
        holdIt($("#widthUp"), () => {
            let currentWidthString = $("#widthInput").val().toString();
            let newWidth;
            newWidth = parseInt(currentWidthString) + 1;
            $("#widthInput").val(newWidth);
            updateWidth();
        }, 1000, 2);
        holdIt($("#widthDown"), () => {
            let currentWidthString = $("#widthInput").val().toString();
            let newWidth;
            newWidth = parseInt(currentWidthString) - 1;
            $("#widthInput").val(newWidth);
            updateWidth();
        }, 1000, 2);
        let updateHeight = function () {
            let newHeight = $("#heightInput").val().toString();
            if (newHeight !== "") {
                for (let node of that.m_diagram.selectedItems.nodes) {
                    if (that.m_keepAspectRatio) {
                        let ratio = node.width / node.height;
                        let diff = parseInt(newHeight) - node.height;
                        node.width = node.width + diff * ratio;
                    }
                    node.height = parseInt(newHeight);
                    that.m_diagram.dataBind();
                    if (that.m_keepAspectRatio)
                        that.updateSelection();
                }
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            }
        };
        holdIt($("#heightUp"), () => {
            let currentHeightString = $("#heightInput").val().toString();
            let newHeight;
            newHeight = parseInt(currentHeightString) + 1;
            $("#heightInput").val(newHeight);
            updateHeight();
        }, 1000, 2);
        holdIt($("#heightDown"), () => {
            let currentHeightString = $("#heightInput").val().toString();
            let newHeight;
            newHeight = parseInt(currentHeightString) - 1;
            $("#heightInput").val(newHeight);
            updateHeight();
        }, 1000, 2);
        // Set up aspect ratio toggle
        $("#aspectRatioToggle").off("change").on("change", () => {
            if ($("#aspectRatioToggle").prop("checked") === true)
                that.m_keepAspectRatio = true;
            else
                that.m_keepAspectRatio = false;
        });
        // Set up colorPicker text
        $("#colorPickerContainerText").empty().append('<input id="colorPickerText" />');
        that.m_colorPickerText = $("#colorPickerText").kendoColorPicker({
            opacity: true,
            value: "#ffffff",
            buttons: false,
            select: (e) => {
                let selectedNodes = that.m_diagram.selectedItems.nodes;
                for (let node of selectedNodes) {
                    node.annotations[0].style.color = e.value;
                    if (node.data["shapeId"] !== DesignShapeId[DesignShapeId.Text])
                        node.style.strokeColor = e.value;
                }
                let selectedConnectors = that.m_diagram.selectedItems.connectors;
                for (let connector of selectedConnectors)
                    connector.annotations[0].style.color = e.value;
                if (!that.m_diagramChanged)
                    $("#processMapPane").trigger("diagramChanged");
            },
            open: () => {
                // Fix for cmdCopy/cmdPaste for colorPicker input field
                $("input.k-color-value").attr("type", "text");
                that.m_diagram.startGroupAction();
            },
            close: () => {
                that.m_diagram.dataBind();
                that.m_diagram.endGroupAction();
            },
        }).data("kendoColorPicker");
        // Set up bold toggle
        $("#boldToggle").off("change").on("change", () => {
            that.m_diagram.startGroupAction();
            if ($("#boldToggle").prop("checked") === true) {
                for (let node of that.m_diagram.selectedItems.nodes)
                    node.annotations[0].style.bold = true;
                for (let connector of that.m_diagram.selectedItems.connectors)
                    connector.annotations[0].style.bold = true;
            }
            else {
                for (let node of that.m_diagram.selectedItems.nodes)
                    node.annotations[0].style.bold = false;
                for (let connector of that.m_diagram.selectedItems.connectors)
                    connector.annotations[0].style.bold = false;
            }
            that.m_diagram.endGroupAction();
            if (!that.m_diagramChanged)
                $("#processMapPane").trigger("diagramChanged");
        });
        // Set up layout buttons
        $("#alignHorizontalLeftButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            if (selectedItems.length >= 2) {
                let leftmostPos;
                for (let node of selectedItems) {
                    if (leftmostPos == undefined) {
                        leftmostPos = node.offsetX - node.width / 2;
                    }
                    else {
                        if (node.offsetX - node.width / 2 < leftmostPos)
                            leftmostPos = node.offsetX - node.width / 2;
                    }
                }
                for (let node of selectedItems)
                    node.offsetX = leftmostPos + node.width / 2;
                that.m_diagram.dataBind();
            }
        });
        $("#alignHorizontalCenterButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            if (selectedItems.length >= 2) {
                let firstNodePos = selectedItems[0].offsetY;
                for (let node of selectedItems)
                    node.offsetY = firstNodePos;
            }
        });
        $("#alignHorizontalRightButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            if (selectedItems.length >= 2) {
                let rightmostPos;
                for (let node of selectedItems) {
                    if (rightmostPos == undefined) {
                        rightmostPos = node.offsetX + node.width / 2;
                    }
                    else {
                        if (node.offsetX + node.width / 2 > rightmostPos)
                            rightmostPos = node.offsetX + node.width / 2;
                    }
                }
                for (let node of selectedItems)
                    node.offsetX = rightmostPos - node.width / 2;
                that.m_diagram.dataBind();
            }
        });
        $("#alignVerticalTopButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            if (selectedItems.length >= 2) {
                let topmostPos;
                for (let node of selectedItems) {
                    if (topmostPos == undefined)
                        topmostPos = node.offsetY - node.height / 2;
                    else {
                        if (node.offsetY - node.height / 2 < topmostPos)
                            topmostPos = node.offsetY - node.height / 2;
                    }
                }
                for (let node of selectedItems)
                    node.offsetY = topmostPos + node.height / 2;
                that.m_diagram.dataBind();
            }
        });
        $("#alignVerticalCenterButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            if (selectedItems.length >= 2) {
                let firstNodePos = selectedItems[0].offsetX;
                for (let node of selectedItems)
                    node.offsetX = firstNodePos;
            }
        });
        $("#alignVerticalBottomButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            if (selectedItems.length >= 2) {
                let bottommostPos;
                for (let node of selectedItems) {
                    if (bottommostPos == undefined) {
                        bottommostPos = node.offsetY + node.height / 2;
                    }
                    else {
                        if (node.offsetY + node.height / 2 > bottommostPos)
                            bottommostPos = node.offsetY + node.height / 2;
                    }
                }
                for (let node of selectedItems)
                    node.offsetY = bottommostPos - node.height / 2;
                that.m_diagram.dataBind();
            }
        });
        $("#distributeHorizontalButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            if (selectedItems.length >= 3) {
                let leftmostNode;
                let rightmostNode;
                for (let node of selectedItems) {
                    if (leftmostNode == undefined && rightmostNode == undefined) {
                        leftmostNode = node;
                        rightmostNode = node;
                    }
                    else {
                        if (node.offsetX - node.width / 2 < leftmostNode.offsetX - leftmostNode.width / 2)
                            leftmostNode = node;
                        if (node.offsetX + node.width / 2 > rightmostNode.offsetX + rightmostNode.width / 2)
                            rightmostNode = node;
                    }
                }
                let availableSpace = (rightmostNode.offsetX - rightmostNode.width / 2) - (leftmostNode.offsetX + leftmostNode.width / 2);
                let nodesToDistribute = [];
                for (let node of selectedItems) {
                    if (node !== leftmostNode && node !== rightmostNode) {
                        nodesToDistribute.push(node);
                        availableSpace -= node.width;
                    }
                }
                let spacing = availableSpace / (selectedItems.length - 2 + 1); // No spacing needed for leftmost/rightmost nodes, +1 is the extra spacing between the last two nodes
                // Sort nodes so they retain their visual order (Check for leftmost edge, if they are the same also take the rightmost edge into consideration)
                nodesToDistribute.sort((firstNode, secondNode) => {
                    if (firstNode.offsetX - firstNode.width / 2 < secondNode.offsetX - secondNode.width / 2)
                        return -1;
                    if (firstNode.offsetX - firstNode.width / 2 > secondNode.offsetX - secondNode.width / 2)
                        return 1;
                    if (firstNode.offsetX + firstNode.width / 2 < secondNode.offsetX + secondNode.width / 2)
                        return -1;
                    if (firstNode.offsetX + firstNode.width / 2 > secondNode.offsetX + secondNode.width / 2)
                        return 1;
                    return 0;
                });
                let startPosX = leftmostNode.offsetX + leftmostNode.width / 2 + spacing;
                for (let node of nodesToDistribute) {
                    node.offsetX = startPosX + node.width / 2;
                    startPosX = node.offsetX + node.width / 2 + spacing;
                }
                that.m_diagram.dataBind();
            }
        });
        $("#distributeVerticalButton").off("click").on("click", (e) => {
            let selectedItems = that.m_diagram.selectedItems.nodes.slice();
            if (selectedItems.length >= 3) {
                let topmostNode;
                let bottommostNode;
                for (let node of selectedItems) {
                    if (topmostNode == undefined && bottommostNode == undefined) {
                        topmostNode = node;
                        bottommostNode = node;
                    }
                    else {
                        if (node.offsetY - node.height / 2 < topmostNode.offsetY - topmostNode.height / 2)
                            topmostNode = node;
                        if (node.offsetY + node.height / 2 > bottommostNode.offsetY + bottommostNode.height / 2)
                            bottommostNode = node;
                    }
                }
                let availableSpace = (bottommostNode.offsetY - bottommostNode.height / 2) - (topmostNode.offsetY + topmostNode.height / 2);
                let nodesToDistribute = [];
                for (let node of selectedItems) {
                    if (node !== topmostNode && node !== bottommostNode) {
                        nodesToDistribute.push(node);
                        availableSpace -= node.height;
                    }
                }
                let spacing = availableSpace / (selectedItems.length - 2 + 1); // No spacing needed for leftmost/rightmost nodes, +1 is the extra spacing between the last two nodes
                // Sort nodes so they retain their visual order (Check for topmost edge, if they are the same also take the bottommost edge into consideration)
                nodesToDistribute.sort((firstNode, secondNode) => {
                    if (firstNode.offsetY - firstNode.height / 2 < secondNode.offsetY - secondNode.height / 2)
                        return -1;
                    if (firstNode.offsetY - firstNode.height / 2 > secondNode.offsetY - secondNode.height / 2)
                        return 1;
                    if (firstNode.offsetY + firstNode.height / 2 < secondNode.offsetY + secondNode.height / 2)
                        return -1;
                    if (firstNode.offsetY + firstNode.height / 2 > secondNode.offsetY + secondNode.height / 2)
                        return 1;
                    return 0;
                });
                let startPosY = topmostNode.offsetY + topmostNode.height / 2 + spacing;
                for (let node of nodesToDistribute) {
                    node.offsetY = startPosY + node.height / 2;
                    startPosY = node.offsetY + node.height / 2 + spacing;
                }
                that.m_diagram.dataBind();
            }
        });
        that.handleDiagramReadonly();
    }
    setDiagramNodeData(diagramNode, node) {
        diagramNode.id = node.id;
        diagramNode.data["shapeId"] = node.type;
        diagramNode.data["id"] = node.synerisId;
        diagramNode.offsetX = node.offsetX;
        diagramNode.offsetY = node.offsetY;
        diagramNode.width = node.width;
        diagramNode.height = node.height;
        diagramNode.rotateAngle = node.rotateAngle;
        diagramNode.style.fill = node.fillColor;
        diagramNode.annotations[0].content = node.label;
        diagramNode.annotations[0].style.fontSize = node.fontSize;
        diagramNode.annotations[0].style.color = node.textColor;
        if (diagramNode.data["shapeId"] !== DesignShapeId[DesignShapeId.Text])
            diagramNode.style.strokeColor = node.textColor;
        else
            diagramNode.style.strokeColor = "none";
        diagramNode.annotations[0].style.bold = node.bold;
    }
    setConnectorData(diagramConnector, connector) {
        diagramConnector.id = connector.id;
        diagramConnector.sourceID = connector.sourceId;
        diagramConnector.targetID = connector.targetId;
        diagramConnector.sourcePortID = connector.sourcePortId;
        diagramConnector.targetPortID = connector.targetPortId;
        if (connector.label)
            diagramConnector.annotations[0].content = connector.label;
        diagramConnector.annotations[0].style.fontSize = connector.fontSize;
        diagramConnector.annotations[0].style.color = connector.textColor;
        diagramConnector.annotations[0].style.bold = connector.bold;
    }
    loadDiagram() {
        let that = this;
        if (that.m_diagramToLoad) {
            // Create fresh diagram
            that.createDiagram();
            // Create nodes and connectors from saved diagram
            for (let node of that.m_diagramToLoad.processNodes) {
                let newDiagramNode;
                // Get shape
                for (let processShape of that.m_processShapes) {
                    if (processShape.id === node.type) {
                        newDiagramNode = JSON.parse(JSON.stringify(processShape));
                        break;
                    }
                }
                if (newDiagramNode == undefined)
                    $.error("Shape not found for node " + node.synerisId + ".");
                // Add node defaults
                that.getNodeDefaults(newDiagramNode);
                if (that.m_readonly) {
                    newDiagramNode.constraints = ej2_diagrams_1.NodeConstraints.None | ej2_diagrams_1.NodeConstraints.PointerEvents | ej2_diagrams_1.NodeConstraints.Select | ej2_diagrams_1.NodeConstraints.InConnect | ej2_diagrams_1.NodeConstraints.OutConnect;
                    newDiagramNode.annotations[0].constraints = ej2_diagrams_1.AnnotationConstraints.ReadOnly;
                }
                // Set data
                that.setDiagramNodeData(newDiagramNode, node);
                that.m_diagram.setActiveLayer("documentLayer");
                that.m_diagram.add(newDiagramNode);
            }
            for (let node of that.m_diagramToLoad.stepNodes) {
                let newDiagramNode;
                // Get shape
                for (let stepShape of that.m_stepsShapes) {
                    if (stepShape.id === node.type) {
                        newDiagramNode = JSON.parse(JSON.stringify(stepShape));
                        break;
                    }
                }
                if (newDiagramNode == undefined)
                    $.error("Shape not found for node " + node.synerisId + ".");
                // Add node defaults
                that.getNodeDefaults(newDiagramNode);
                if (that.m_readonly) {
                    newDiagramNode.constraints = ej2_diagrams_1.NodeConstraints.None | ej2_diagrams_1.NodeConstraints.PointerEvents | ej2_diagrams_1.NodeConstraints.Select | ej2_diagrams_1.NodeConstraints.InConnect | ej2_diagrams_1.NodeConstraints.OutConnect;
                    newDiagramNode.annotations[0].constraints = ej2_diagrams_1.AnnotationConstraints.ReadOnly;
                }
                // Set data
                that.setDiagramNodeData(newDiagramNode, node);
                that.m_diagram.setActiveLayer("documentLayer");
                that.m_diagram.add(newDiagramNode);
            }
            for (let designNode of that.m_diagramToLoad.designNodes) {
                let newDiagramNode;
                // Get shape
                for (let designShape of that.m_designShapes) {
                    if (designShape.id === designNode.type) {
                        newDiagramNode = JSON.parse(JSON.stringify(designShape));
                        break;
                    }
                }
                if (newDiagramNode == undefined)
                    $.error("Shape not found for node " + designNode.synerisId + ".");
                // Add node defaults
                that.getNodeDefaults(newDiagramNode);
                if (that.m_readonly) {
                    newDiagramNode.constraints = ej2_diagrams_1.NodeConstraints.None;
                    newDiagramNode.annotations[0].constraints = ej2_diagrams_1.AnnotationConstraints.ReadOnly;
                }
                // Set data
                that.setDiagramNodeData(newDiagramNode, designNode);
                if (designNode.type === DesignShapeId[DesignShapeId.Text])
                    that.m_diagram.setActiveLayer("documentLayer");
                else
                    that.m_diagram.setActiveLayer("designLayer");
                that.m_diagram.add(newDiagramNode);
            }
            for (let connector of that.m_diagramToLoad.connectors) {
                let newDiagramConnector;
                // Get shape
                for (let connectorShape of that.m_connectors) {
                    if (connectorShape.type === connector.type) {
                        newDiagramConnector = JSON.parse(JSON.stringify(connectorShape));
                        break;
                    }
                }
                if (newDiagramConnector == undefined)
                    $.error("Shape not found for connector " + connector.id + ".");
                // Add connector defaults
                that.getConnectorDefaults(newDiagramConnector);
                if (that.m_readonly) {
                    newDiagramConnector.constraints = ej2_diagrams_1.ConnectorConstraints.None;
                    newDiagramConnector.annotations[0].constraints = ej2_diagrams_1.AnnotationConstraints.ReadOnly;
                }
                // Set data
                that.setConnectorData(newDiagramConnector, connector);
                that.m_diagram.setActiveLayer("documentLayer");
                that.m_diagram.add(newDiagramConnector);
            }
            // Refresh needed to get rid of undo/redo steps
            that.m_diagram.refresh();
            // Fit diagram to page
            that.m_diagram.fitToPage();
            // Handle non-empty diagram for UI
            that.updateToggleButton();
            // Update selection (Is necessary after node navigation)
            that.updateSelection();
            $("#processMapPane").trigger("diagramChanged");
        }
    }
    handleDiagramReadonly() {
        let that = this;
        // Set constraints, hide sidebar and change styles if read-only
        if (that.m_readonly) {
            that.m_diagram.constraints = ej2_diagrams_1.DiagramConstraints.Default & ~ej2_diagrams_1.DiagramConstraints.PageEditable | ej2_diagrams_1.DiagramConstraints.UserInteraction;
            let gridlines = { lineColor: "transparent" };
            that.m_diagram.snapSettings = { horizontalGridlines: gridlines, verticalGridlines: gridlines };
            $("#sidebar").css("display", "none");
            that.m_diagram.refresh();
        }
        else
            $("#sidebar").css("display", "flex");
    }
    diagramIsEmpty() {
        let that = this;
        if (that.m_diagram.connectors.length === 0 && that.m_diagram.nodes.length === 0)
            return true;
        else
            return false;
    }
    loadedDiagramIsEmpty() {
        let that = this;
        if (that.m_diagramToLoad.connectors.length === 0 && that.m_diagramToLoad.processNodes.length === 0 && that.m_diagramToLoad.stepNodes.length === 0 && that.m_diagramToLoad.designNodes.length === 0)
            return true;
        else
            return false;
    }
    diagramHasChanged() {
        let that = this;
        let currentDiagram = that.saveDiagramToSynerisDiagram();
        let loadedDiagram = that.m_diagramToLoad;
        if (JSON.stringify(currentDiagram) === JSON.stringify(loadedDiagram))
            return false;
        else
            return true;
    }
    saveDiagramToSynerisDiagram() {
        let that = this;
        let synerisDiagram = {
            processNodes: [],
            designNodes: [],
            stepNodes: [],
            connectors: [],
        };
        if (!this.diagramIsEmpty()) {
            // Create nodes
            for (let node of that.m_diagram.nodes) {
                let isDesignShape = false;
                if (node.data["isDesignShape"] === true)
                    isDesignShape = true;
                let newNode = {
                    id: node.id,
                    type: node.data["shapeId"],
                    offsetX: node.offsetX,
                    offsetY: node.offsetY,
                    width: node.width,
                    height: node.height,
                    rotateAngle: node.rotateAngle,
                    fillColor: node.style.fill,
                    label: node.annotations[0].content,
                    fontSize: node.annotations[0].style.fontSize,
                    textColor: node.annotations[0].style.color,
                    bold: node.annotations[0].style.bold,
                };
                if (node.data["id"])
                    newNode.synerisId = node.data["id"];
                if (isDesignShape)
                    synerisDiagram.designNodes.push(newNode);
                else {
                    if (that.m_viewMode === ViewMode.ProcessView)
                        that.addProcessNode(synerisDiagram, newNode);
                    else
                        that.addStepNode(synerisDiagram, newNode);
                }
            }
            // Create connectors
            for (let connector of that.m_diagram.connectors) {
                let newConnector = {
                    id: connector.id,
                    type: connector.type,
                    sourceId: connector.sourceID,
                    targetId: connector.targetID,
                    sourcePortId: connector.sourcePortID,
                    targetPortId: connector.targetPortID,
                    label: connector.annotations[0].content,
                    fontSize: connector.annotations[0].style.fontSize,
                    textColor: connector.annotations[0].style.color,
                    bold: connector.annotations[0].style.bold,
                };
                synerisDiagram.connectors.push(newConnector);
            }
        }
        return synerisDiagram;
    }
    addProcessNode(diagramJSON, node) {
        // Add process node to diagram
        diagramJSON.processNodes.push(node);
    }
    addStepNode(diagramJSON, node) {
        // Add step node to diagram
        diagramJSON.stepNodes.push(node);
    }
    removeNode(diagramJSON, node) {
        let that = this;
        // Remove all connectors connected to node
        let connectors = [];
        for (let connector of diagramJSON.connectors)
            if (connector.sourceId === node.id || connector.targetId === node.id)
                connectors.push(connector);
        for (let connector of connectors)
            that.removeConnector(diagramJSON, connector);
        // Remove node from diagram
        for (let i = diagramJSON.processNodes.length - 1; i >= 0; --i)
            if (diagramJSON.processNodes[i].id === node.id)
                diagramJSON.processNodes.splice(i, 1);
        for (let i = diagramJSON.stepNodes.length - 1; i >= 0; --i)
            if (diagramJSON.stepNodes[i].id === node.id)
                diagramJSON.stepNodes.splice(i, 1);
    }
    addConnector(diagramJSON, connector) {
        // Add connector to diagram
        diagramJSON.connectors.push(connector);
    }
    removeConnector(diagramJSON, connector) {
        // Remove connector from diagram
        for (let i = diagramJSON.connectors.length - 1; i >= 0; --i)
            if (diagramJSON.connectors[i].id === connector.id)
                diagramJSON.connectors.splice(i, 1);
    }
    updateToggleButton() {
        let that = this;
        if (that.m_viewMode === ViewMode.ProcessView)
            $("#toggleModeButton").text(Utilities_1.synUtil.Strings.getValue("processmap.processes"));
        else
            $("#toggleModeButton").text(Utilities_1.synUtil.Strings.getValue("processmap.steps"));
        if (that.diagramIsEmpty() && that.loadedDiagramIsEmpty() && that.m_typeId !== that.m_typeIdProcessMap) {
            $("#toggleModeButton").removeClass("k-state-disabled");
            $("#toggleModeButton").removeAttr("disabled");
        }
        else {
            $("#toggleModeButton").addClass("k-state-disabled");
            $("#toggleModeButton").attr("disabled", "disabled");
        }
    }
    syncProcess(isSave = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            that.m_layoutSaveFailed = false;
            let currentDiagram;
            if (isSave)
                currentDiagram = that.saveDiagramToSynerisDiagram();
            else
                currentDiagram = that.m_diagramToLoad;
            // Get current instance
            try {
                that.m_instance = yield Utilities_1.synUtil.getInstanceAsync(that.m_instance.id.valueAsString);
            }
            catch (ex) {
                that.m_layoutSaveFailed = true;
                return Promise.reject("Get instance failed");
            }
            // On save, save the layout
            if (isSave) {
                that.m_instance.items["ceproclk.layout"].valueAsString = JSON.stringify(currentDiagram);
                try {
                    const instTmp = yield Utilities_1.synUtil.getAJAXDataAsync({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                        requestData: { instance: JSON.stringify(that.m_instance.toJSON()) },
                    });
                    that.m_instance = yield Instance_1.Instance.fromJSON(instTmp);
                }
                catch (ex) {
                    that.m_layoutSaveFailed = true;
                    return Promise.reject("Layout save failed");
                }
            }
            // Get children
            let childFieldNames = ["id", "cgdocument.doclabel", "cgdocstructure.structuretype"];
            let relId;
            if (that.m_typeId === that.m_typeIdProcessMap)
                relId = that.m_processMapRelIdProcesses;
            else
                relId = that.m_processRelIdProcesses;
            let resultsId = yield Utilities_1.synUtil.getAJAXDataAsync({
                url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + that.m_id + "/" + relId,
                requestData: {},
            });
            let children = yield Utilities_1.synUtil.getAJAXDataAsync({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                requestData: {
                    fieldNames: JSON.stringify(childFieldNames),
                    oneShot: "true",
                },
            });
            // Compare diagram to syneris
            let diagramNodesToRemove = [];
            let createProcess = function (newProcessNode, synerisDocumentExists) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let relId;
                    if (that.m_typeId === that.m_typeIdProcessMap)
                        relId = that.m_processMapRelIdProcesses;
                    else
                        relId = that.m_processRelIdProcesses;
                    try {
                        if (synerisDocumentExists) {
                            yield Utilities_1.synUtil.getAJAXDataAsync({
                                method: "PUT",
                                url: Utilities_1.synUtil.getWSUrl("InstanceAddChildren") + that.m_instance.id.value + "/" + relId,
                                requestData: JSON.stringify({ instances: [newProcessNode.synerisId] }),
                            });
                        }
                        else {
                            let template = yield Utilities_1.synUtil.getTemplateAsync(parseInt(that.m_typeIdProcess, 10), Base_1.PropertyPageMode.New);
                            template.items["cgdocument.doclabel"].valueAsString = newProcessNode.label;
                            let newProcessInstance = yield Utilities_1.synUtil.getAJAXDataAsync({
                                method: "PUT",
                                url: Utilities_1.synUtil.getWSUrl("InstanceCreate"),
                                requestData: {
                                    instance: JSON.stringify(template.toJSON()),
                                    parentId: that.m_instance.id.value,
                                    parentRelId: parseInt(relId),
                                },
                            });
                            newProcessNode.synerisId = newProcessInstance.id.value;
                        }
                    }
                    catch (ex) {
                        return Promise.reject(ex);
                    }
                });
            };
            for (let diagramNode of currentDiagram.processNodes) {
                let nodeFound = false;
                if (diagramNode.synerisId) {
                    for (let synerisProcess of children.data) {
                        if (diagramNode.synerisId === synerisProcess.id.value) {
                            nodeFound = true;
                            break;
                        }
                    }
                }
                if (!nodeFound) {
                    // Diagram has node that is missing in syneris
                    // Check if syneris document still exists
                    let synerisDocumentExists = false;
                    if (diagramNode.synerisId) {
                        try {
                            yield Utilities_1.synUtil.getInstanceAsync(diagramNode.synerisId);
                            synerisDocumentExists = true;
                        }
                        catch (ex) {
                            // Do nothing, document does not exist
                        }
                    }
                    if (isSave) {
                        // Always create/link new process
                        try {
                            yield createProcess(diagramNode, synerisDocumentExists);
                        }
                        catch (ex) {
                            return Promise.reject(ex);
                        }
                    }
                    else {
                        // Ask user
                        let choiceId;
                        if (synerisDocumentExists) {
                            choiceId = yield Utilities_1.synUtil.choice({
                                allowCancel: false,
                                text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.choicelinkprocess")), diagramNode.label),
                                options: [
                                    {
                                        id: 1,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.linkprocess"),
                                    }, {
                                        id: 2,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.removediagramprocess"),
                                    }
                                ],
                            });
                        }
                        else {
                            choiceId = yield Utilities_1.synUtil.choice({
                                allowCancel: false,
                                text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.choicecreateprocess")), diagramNode.label),
                                options: [
                                    {
                                        id: 1,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.createprocess"),
                                    }, {
                                        id: 2,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.removediagramprocess"),
                                    }
                                ],
                            });
                        }
                        if (choiceId === 1) {
                            // Create new process
                            try {
                                yield createProcess(diagramNode, synerisDocumentExists);
                            }
                            catch (ex) {
                                return Promise.reject(ex);
                            }
                        }
                        else if (choiceId === 2) {
                            // Mark node for removal
                            diagramNodesToRemove.push(diagramNode);
                        }
                    }
                }
            }
            // Remove nodes
            for (let node of diagramNodesToRemove)
                that.removeNode(currentDiagram, node);
            // Compare syneris to diagram (and update doclabels)
            let removeProcess = function (synerisProcess) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let relId;
                    if (that.m_typeId === that.m_typeIdProcessMap)
                        relId = that.m_processMapRelIdProcesses;
                    else
                        relId = that.m_processRelIdProcesses;
                    let dataobj = {
                        "cefunc.25forceremove": true
                    };
                    try {
                        yield Utilities_1.synUtil.executeMethodAsync({
                            method: "cefunc.25",
                            ids: [synerisProcess.id.value],
                            parentId: that.m_instance.id.value,
                            relId: parseInt(relId),
                            additionalData: dataobj,
                        });
                    }
                    catch (ex) {
                        return Promise.reject("cefunc.25 failed");
                    }
                });
            };
            let updateProcessDoclabel = function (synerisProcess, newDocLabel) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    try {
                        let childProcessInstance = yield Utilities_1.synUtil.getInstanceAsync(synerisProcess.id.value);
                        childProcessInstance.items["cgdocument.doclabel"].valueAsString = newDocLabel;
                        yield Utilities_1.synUtil.getAJAXDataAsync({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                            requestData: { instance: JSON.stringify(childProcessInstance.toJSON()) },
                        });
                    }
                    catch (ex) {
                        return Promise.reject("Update doclabel failed.");
                    }
                });
            };
            let xOffset = 0;
            let yOffset = 0;
            for (let synerisProcess of children.data) {
                let processFound = false;
                let foundDiagramNode;
                for (let diagramNode of currentDiagram.processNodes) {
                    if (synerisProcess.id.value === diagramNode.synerisId) {
                        processFound = true;
                        foundDiagramNode = diagramNode;
                        break;
                    }
                }
                if (processFound) {
                    // Existing node, only update doclabel
                    let processDoclabel = synerisProcess.items["cgdocument.doclabel"].valueAsString;
                    let diagramNodeDocLabel = foundDiagramNode.label;
                    if (processDoclabel !== diagramNodeDocLabel) {
                        if (isSave) {
                            // Always overwrite syneris doclabel with diagramNode label
                            try {
                                yield updateProcessDoclabel(synerisProcess, diagramNodeDocLabel);
                            }
                            catch (ex) {
                                return Promise.reject(ex);
                            }
                        }
                        else {
                            // Ask user
                            let choiceId = yield Utilities_1.synUtil.choice({
                                allowCancel: false,
                                text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.selectdoclabel")), processDoclabel, diagramNodeDocLabel),
                                options: [
                                    {
                                        id: 1,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.usedoclabeldiagram"),
                                    }, {
                                        id: 2,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.usedoclabelsyneris"),
                                    }
                                ],
                            });
                            if (choiceId === 1) {
                                // Set doclabel syneris
                                try {
                                    yield updateProcessDoclabel(synerisProcess, diagramNodeDocLabel);
                                }
                                catch (ex) {
                                    return Promise.reject(ex);
                                }
                            }
                            else if (choiceId === 2) {
                                // Set doclabel diagram
                                foundDiagramNode.label = processDoclabel;
                            }
                        }
                    }
                }
                else {
                    if (isSave) {
                        // Always remove the syneris process
                        try {
                            yield removeProcess(synerisProcess);
                        }
                        catch (ex) {
                            return Promise.reject(ex);
                        }
                    }
                    else {
                        // Ask user
                        let choiceId = yield Utilities_1.synUtil.choice({
                            allowCancel: false,
                            text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.choiceremoveprocess")), synerisProcess.items["cgdocument.doclabel"].valueAsString),
                            options: [
                                {
                                    id: 1,
                                    text: Utilities_1.synUtil.Strings.getValue("processmap.removeprocess"),
                                }, {
                                    id: 2,
                                    text: Utilities_1.synUtil.Strings.getValue("processmap.adddiagramprocess"),
                                }
                            ],
                        });
                        if (choiceId === 1) {
                            // Remove syneris process
                            try {
                                yield removeProcess(synerisProcess);
                            }
                            catch (ex) {
                                return Promise.reject(ex);
                            }
                        }
                        else if (choiceId === 2) {
                            // Add diagram process
                            let newNode = {
                                id: "guid" + Utilities_1.synUtil.getGUID(true),
                                type: ProcessShapeId[ProcessShapeId.ProcessSquare],
                                synerisId: synerisProcess.id.value,
                                offsetX: xOffset,
                                offsetY: yOffset,
                                width: 100,
                                height: 100,
                                rotateAngle: 0,
                                fillColor: "#ffffff",
                                label: synerisProcess.items["cgdocument.doclabel"].valueAsString,
                                fontSize: 12,
                                textColor: "#245c86",
                                bold: false,
                            };
                            that.addProcessNode(currentDiagram, newNode);
                            xOffset += 20;
                            yOffset += 20;
                        }
                    }
                }
            }
            // Always save the layout (possible changes due to conflict resolutions)
            that.m_instance.items["ceproclk.layout"].valueAsString = JSON.stringify(currentDiagram);
            try {
                const instTmp = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                    requestData: { instance: JSON.stringify(that.m_instance.toJSON()) },
                });
                that.m_instance = yield Instance_1.Instance.fromJSON(instTmp);
            }
            catch (ex) {
                that.m_layoutSaveFailed = true;
                return Promise.reject("Layout save after creating new nodes failed");
            }
            that.m_diagramToLoad = currentDiagram;
            // Add new synerisIds to the syncFusion diagram nodes on save
            if (isSave) {
                for (let process of currentDiagram.processNodes) {
                    if (process.synerisId) {
                        for (let node of that.m_diagram.nodes) {
                            if (node.id === process.id) {
                                node.data["id"] = process.synerisId;
                                break;
                            }
                        }
                    }
                }
            }
            return Promise.resolve();
        });
    }
    syncSteps(isSave = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            that.m_layoutSaveFailed = false;
            let currentDiagram;
            if (isSave)
                currentDiagram = that.saveDiagramToSynerisDiagram();
            else
                currentDiagram = that.m_diagramToLoad;
            // Get current instance
            try {
                that.m_instance = yield Utilities_1.synUtil.getInstanceAsync(that.m_instance.id.valueAsString);
            }
            catch (ex) {
                that.m_layoutSaveFailed = true;
                return Promise.reject("Get instance failed");
            }
            // On save, save the layout
            if (isSave) {
                that.m_instance.items["ceproclk.layout"].valueAsString = JSON.stringify(currentDiagram);
                try {
                    const instTmp = yield Utilities_1.synUtil.getAJAXDataAsync({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                        requestData: { instance: JSON.stringify(that.m_instance.toJSON()) },
                    });
                    that.m_instance = yield Instance_1.Instance.fromJSON(instTmp);
                }
                catch (ex) {
                    that.m_layoutSaveFailed = true;
                    return Promise.reject("Layout save failed");
                }
            }
            // Get children
            let childFieldNames = ["id", "cgdocument.doclabel", "cgdocstructure.structuretype"];
            let relId = that.m_processRelIdProcessSteps;
            let resultsId = yield Utilities_1.synUtil.getAJAXDataAsync({
                url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + that.m_id + "/" + relId,
                requestData: {},
            });
            let children = yield Utilities_1.synUtil.getAJAXDataAsync({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                requestData: {
                    fieldNames: JSON.stringify(childFieldNames),
                    oneShot: "true",
                },
            });
            // Compare diagram steps to syneris
            let diagramNodesToRemove = [];
            let createStep = function (newStepNode, synerisDocumentExists) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let relId = that.m_processRelIdProcessSteps;
                    try {
                        if (synerisDocumentExists) {
                            yield Utilities_1.synUtil.getAJAXDataAsync({
                                method: "PUT",
                                url: Utilities_1.synUtil.getWSUrl("InstanceAddChildren") + that.m_instance.id.value + "/" + relId,
                                requestData: JSON.stringify({ instances: [newStepNode.synerisId] }),
                            });
                        }
                        else {
                            let template = yield Utilities_1.synUtil.getTemplateAsync(parseInt(that.m_typeIdProcessStep, 10), Base_1.PropertyPageMode.New);
                            template.items["cgdocument.doclabel"].valueAsString = newStepNode.label;
                            let newStepInstance = yield Utilities_1.synUtil.getAJAXDataAsync({
                                method: "PUT",
                                url: Utilities_1.synUtil.getWSUrl("InstanceCreate"),
                                requestData: {
                                    instance: JSON.stringify(template.toJSON()),
                                    parentId: that.m_instance.id.value,
                                    parentRelId: parseInt(relId),
                                },
                            });
                            newStepNode.synerisId = newStepInstance.id.value;
                        }
                    }
                    catch (ex) {
                        return Promise.reject(ex);
                    }
                });
            };
            for (let diagramNode of currentDiagram.stepNodes) {
                let nodeFound = false;
                if (diagramNode.synerisId) {
                    for (let synerisStep of children.data) {
                        if (diagramNode.synerisId === synerisStep.id.value) {
                            nodeFound = true;
                            break;
                        }
                    }
                }
                if (!nodeFound) {
                    // Diagram has node that is missing in syneris
                    // Check if syneris document still exists
                    let synerisDocumentExists = false;
                    if (diagramNode.synerisId) {
                        try {
                            yield Utilities_1.synUtil.getInstanceAsync(diagramNode.synerisId);
                            synerisDocumentExists = true;
                        }
                        catch (ex) {
                            // Do nothing, document does not exist
                        }
                    }
                    if (isSave) {
                        // Always create/link new step
                        try {
                            yield createStep(diagramNode, synerisDocumentExists);
                        }
                        catch (ex) {
                            return Promise.reject(ex);
                        }
                    }
                    else {
                        // Ask user
                        let choiceId;
                        if (synerisDocumentExists) {
                            choiceId = yield Utilities_1.synUtil.choice({
                                allowCancel: false,
                                text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.choicelinkstep")), diagramNode.label),
                                options: [
                                    {
                                        id: 1,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.linkstep"),
                                    }, {
                                        id: 2,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.removediagramstep"),
                                    }
                                ],
                            });
                        }
                        else {
                            choiceId = yield Utilities_1.synUtil.choice({
                                allowCancel: false,
                                text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.choicecreatestep")), diagramNode.label),
                                options: [
                                    {
                                        id: 1,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.createstep"),
                                    }, {
                                        id: 2,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.removediagramstep"),
                                    }
                                ],
                            });
                        }
                        if (choiceId === 1) {
                            // Create/link new step
                            try {
                                yield createStep(diagramNode, synerisDocumentExists);
                            }
                            catch (ex) {
                                return Promise.reject(ex);
                            }
                        }
                        else if (choiceId === 2)
                            // Mark node for removal
                            diagramNodesToRemove.push(diagramNode);
                    }
                }
            }
            // Remove nodes
            for (let node of diagramNodesToRemove)
                that.removeNode(currentDiagram, node);
            // Compare syneris steps to diagram (and update doclabels)
            let removeStep = function (synerisStep) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let relId = that.m_processRelIdProcessSteps;
                    let dataobj = {
                        "cefunc.25forceremove": true
                    };
                    try {
                        yield Utilities_1.synUtil.executeMethodAsync({
                            method: "cefunc.25",
                            ids: [synerisStep.id.value],
                            parentId: that.m_instance.id.value,
                            relId: parseInt(relId),
                            additionalData: dataobj,
                        });
                    }
                    catch (ex) {
                        return Promise.reject("cefunc.25 failed");
                    }
                    // Also remove all connectors from the removed step
                    try {
                        let resultsIdNextSteps = yield Utilities_1.synUtil.getAJAXDataAsync({
                            url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + synerisStep.id.value + "/" + that.m_stepRelIdPrevNextStep,
                            requestData: {},
                        });
                        let nextSteps = yield Utilities_1.synUtil.getAJAXDataAsync({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("Results") + resultsIdNextSteps,
                            requestData: {
                                fieldNames: JSON.stringify(childFieldNames),
                                oneShot: "true",
                            },
                        });
                        let idsToRemove = [];
                        for (let nextStep of nextSteps.data)
                            idsToRemove.push(nextStep["id"].value);
                        yield Utilities_1.synUtil.executeMethodAsync({
                            method: "cefunc.25",
                            ids: idsToRemove,
                            parentId: synerisStep.id.value,
                            relId: parseInt(that.m_stepRelIdPrevNextStep),
                            additionalData: dataobj,
                        });
                    }
                    catch (ex) {
                        return Promise.reject("cefunc.25 for connectors failed");
                    }
                });
            };
            let updateStepDoclabel = function (synerisStep, newDocLabel) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    try {
                        let childStepInstance = yield Utilities_1.synUtil.getInstanceAsync(synerisStep.id.value);
                        childStepInstance.items["cgdocument.doclabel"].valueAsString = newDocLabel;
                        yield Utilities_1.synUtil.getAJAXDataAsync({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                            requestData: { instance: JSON.stringify(childStepInstance.toJSON()) },
                        });
                    }
                    catch (ex) {
                        return Promise.reject("Update doclabel failed");
                    }
                });
            };
            let xOffset = 0;
            let yOffset = 0;
            for (let synerisStep of children.data) {
                let stepFound = false;
                let foundDiagramNode;
                for (let diagramNode of currentDiagram.stepNodes) {
                    if (synerisStep.id.value === diagramNode.synerisId) {
                        stepFound = true;
                        foundDiagramNode = diagramNode;
                        break;
                    }
                }
                if (stepFound) {
                    // Existing node, only update doclabel
                    let stepDoclabel = synerisStep.items["cgdocument.doclabel"].valueAsString;
                    let diagramNodeDocLabel = foundDiagramNode.label;
                    if (stepDoclabel !== diagramNodeDocLabel) {
                        if (isSave) {
                            // Always overwrite syneris doclabel with diagramNode label
                            try {
                                yield updateStepDoclabel(synerisStep, diagramNodeDocLabel);
                            }
                            catch (ex) {
                                return Promise.reject(ex);
                            }
                        }
                        else {
                            // Ask user
                            let choiceId = yield Utilities_1.synUtil.choice({
                                allowCancel: false,
                                text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.selectdoclabel")), stepDoclabel, diagramNodeDocLabel),
                                options: [
                                    {
                                        id: 1,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.usedoclabeldiagram"),
                                    }, {
                                        id: 2,
                                        text: Utilities_1.synUtil.Strings.getValue("processmap.usedoclabelsyneris"),
                                    }
                                ],
                            });
                            if (choiceId === 1) {
                                // Set doclabel syneris
                                try {
                                    yield updateStepDoclabel(synerisStep, diagramNodeDocLabel);
                                }
                                catch (ex) {
                                    return Promise.reject(ex);
                                }
                            }
                            else if (choiceId === 2)
                                // Set doclabel diagram
                                foundDiagramNode.label = stepDoclabel;
                        }
                    }
                }
                else {
                    if (isSave) {
                        // Always remove the syneris step
                        try {
                            yield removeStep(synerisStep);
                        }
                        catch (ex) {
                            return Promise.reject(ex);
                        }
                    }
                    else {
                        // Ask user
                        let choiceId = yield Utilities_1.synUtil.choice({
                            allowCancel: false,
                            text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.choiceremovestep")), synerisStep.items["cgdocument.doclabel"].valueAsString),
                            options: [
                                {
                                    id: 1,
                                    text: Utilities_1.synUtil.Strings.getValue("processmap.removestep"),
                                }, {
                                    id: 2,
                                    text: Utilities_1.synUtil.Strings.getValue("processmap.adddiagramstep"),
                                }
                            ],
                        });
                        if (choiceId === 1) {
                            // Remove syneris step
                            try {
                                yield removeStep(synerisStep);
                            }
                            catch (ex) {
                                return Promise.reject(ex);
                            }
                        }
                        else if (choiceId === 2) {
                            // Add diagram step
                            let newNode = {
                                id: "guid" + Utilities_1.synUtil.getGUID(true),
                                type: StepShapeId[StepShapeId.StepSquare],
                                synerisId: synerisStep.id.value,
                                offsetX: xOffset,
                                offsetY: yOffset,
                                width: 100,
                                height: 100,
                                rotateAngle: 0,
                                fillColor: "#ffffff",
                                label: synerisStep.items["cgdocument.doclabel"].valueAsString,
                                fontSize: 12,
                                textColor: "#245c86",
                                bold: false,
                            };
                            that.addStepNode(currentDiagram, newNode);
                            xOffset += 20;
                            yOffset += 20;
                        }
                    }
                }
            }
            // Compare connectors for steps, must be a while loop because conflict resolutions can add new steps
            let removeNextStep = function (childStep, nextStepId) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let relId = that.m_stepRelIdPrevNextStep;
                    let dataobj = {
                        "cefunc.25forceremove": true
                    };
                    try {
                        yield Utilities_1.synUtil.executeMethodAsync({
                            method: "cefunc.25",
                            ids: [nextStepId],
                            parentId: childStep.synerisId,
                            relId: parseInt(relId),
                            additionalData: dataobj,
                        });
                    }
                    catch (ex) {
                        return Promise.reject("cefunc.25 failed");
                    }
                });
            };
            let currentChildStep = currentDiagram.stepNodes[0];
            let stepNodesIndex = 0;
            while (currentChildStep) {
                // Get syneris nextChild
                let resultsIdNextStep = yield Utilities_1.synUtil.getAJAXDataAsync({
                    url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + currentChildStep.synerisId + "/" + that.m_stepRelIdPrevNextStep,
                    requestData: {},
                });
                let childFieldNames = ["id", "cgdocument.doclabel", "cgdocstructure.structuretype"];
                let nextStepChildren = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("Results") + resultsIdNextStep,
                    requestData: {
                        fieldNames: JSON.stringify(childFieldNames),
                        oneShot: "true",
                    }
                });
                let synerisNextStepHandledIds = [];
                if (nextStepChildren.total > 0) {
                    for (let nextStepChildData of nextStepChildren.data) {
                        let nextStepId = nextStepChildData.id.value;
                        let nextStepLabel = nextStepChildData.items["cgdocument.doclabel"].valueAsString;
                        // Find step with syneris id in diagram
                        let nextStepNode;
                        for (let stepNode of currentDiagram.stepNodes) {
                            if (stepNode.synerisId === nextStepId) {
                                nextStepNode = stepNode;
                                break;
                            }
                        }
                        if (nextStepNode == undefined) {
                            // Next step hasn't been found in diagram
                            if (isSave) {
                                // Always remove the connection
                                try {
                                    yield removeNextStep(currentChildStep, nextStepId);
                                }
                                catch (ex) {
                                    return Promise.reject(ex);
                                }
                            }
                            else {
                                // Ask user
                                let choiceId = yield Utilities_1.synUtil.choice({
                                    allowCancel: false,
                                    text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.choiceremovenextsteporaddstep")), currentChildStep.label, nextStepLabel),
                                    options: [
                                        {
                                            id: 1,
                                            text: Utilities_1.synUtil.Strings.getValue("processmap.removenextstepsyneris"),
                                        }, {
                                            id: 2,
                                            text: Utilities_1.synUtil.Strings.getValue("processmap.addnextsteptodiagram"),
                                        }
                                    ],
                                });
                                if (choiceId === 1) {
                                    // Remove nextStep
                                    try {
                                        yield removeNextStep(currentChildStep, nextStepId);
                                    }
                                    catch (ex) {
                                        return Promise.reject(ex);
                                    }
                                }
                                else if (choiceId === 2) {
                                    // Add nextStep and connection to diagram
                                    let newNode = {
                                        id: "guid" + Utilities_1.synUtil.getGUID(true),
                                        type: StepShapeId[StepShapeId.StepSquare],
                                        synerisId: nextStepId,
                                        offsetX: xOffset,
                                        offsetY: yOffset,
                                        width: 100,
                                        height: 100,
                                        rotateAngle: 0,
                                        fillColor: "#ffffff",
                                        label: nextStepLabel,
                                        fontSize: 12,
                                        textColor: "#245c86",
                                        bold: false,
                                    };
                                    that.addStepNode(currentDiagram, newNode);
                                    xOffset += 20;
                                    yOffset += 20;
                                    // Also add connector
                                    let newConnector = {
                                        id: "guid" + Utilities_1.synUtil.getGUID(true),
                                        type: ConnectorId[ConnectorId.Orthogonal],
                                        sourceId: currentChildStep.id,
                                        targetId: newNode.id,
                                        sourcePortId: "portE",
                                        targetPortId: "portW",
                                        fontSize: 12,
                                        textColor: "#245c86",
                                        bold: false,
                                    };
                                    that.addConnector(currentDiagram, newConnector);
                                    // Also add child instance to syneris object (Could be missing if just a nextStep was linked, but the step wasn't linked under the process document)
                                    try {
                                        yield Utilities_1.synUtil.getAJAXDataAsync({
                                            method: "PUT",
                                            url: Utilities_1.synUtil.getWSUrl("InstanceAddChildren") + that.m_instance.id.value + "/" + that.m_processRelIdProcessSteps,
                                            requestData: JSON.stringify({ instances: [nextStepId] }),
                                        });
                                    }
                                    catch (ex) {
                                        return Promise.reject("Failed InstanceAddChildren for parentId \"" + that.m_instance.id.value + "\" and childId \"" + nextStepId + "\".");
                                    }
                                }
                            }
                        }
                        else {
                            // Next step has been found in diagram, search connector
                            let connectorFound = false;
                            for (let diagramConnector of currentDiagram.connectors) {
                                if (diagramConnector.sourceId === currentChildStep.id && diagramConnector.targetId === nextStepNode.id) {
                                    connectorFound = true;
                                    break;
                                }
                            }
                            if (!connectorFound) {
                                if (isSave) {
                                    // Always remove the connection
                                    try {
                                        yield removeNextStep(currentChildStep, nextStepId);
                                    }
                                    catch (ex) {
                                        return Promise.reject(ex);
                                    }
                                }
                                else {
                                    // Ask user
                                    let choiceId = yield Utilities_1.synUtil.choice({
                                        allowCancel: false,
                                        text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.choiceremovenextsteporaddconnector")), currentChildStep.label, nextStepLabel),
                                        options: [
                                            {
                                                id: 1,
                                                text: Utilities_1.synUtil.Strings.getValue("processmap.removenextstepsyneris"),
                                            }, {
                                                id: 2,
                                                text: Utilities_1.synUtil.Strings.getValue("processmap.addconnectortodiagram"),
                                            }
                                        ],
                                    });
                                    if (choiceId === 1) {
                                        // Remove nextStep
                                        try {
                                            yield removeNextStep(currentChildStep, nextStepId);
                                        }
                                        catch (ex) {
                                            return Promise.reject(ex);
                                        }
                                    }
                                    else if (choiceId === 2) {
                                        // Add connector to diagram
                                        let newConnector = {
                                            id: "guid" + Utilities_1.synUtil.getGUID(true),
                                            type: ConnectorId[ConnectorId.Orthogonal],
                                            sourceId: currentChildStep.id,
                                            targetId: nextStepNode.id,
                                            sourcePortId: "portE",
                                            targetPortId: "portW",
                                            fontSize: 12,
                                            textColor: "#245c86",
                                            bold: false,
                                        };
                                        that.addConnector(currentDiagram, newConnector);
                                    }
                                }
                            }
                        }
                        synerisNextStepHandledIds.push(nextStepId);
                    }
                }
                // Check for diagram connection that is missing in syneris
                let addNextStep = function (currentChildStepSynerisId, nextStepSynerisId) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let relId = that.m_stepRelIdPrevNextStep;
                        try {
                            yield Utilities_1.synUtil.getAJAXDataAsync({
                                method: "PUT",
                                url: Utilities_1.synUtil.getWSUrl("InstanceAddChildren") + currentChildStepSynerisId + "/" + relId,
                                requestData: JSON.stringify({ instances: [nextStepSynerisId] }),
                            });
                        }
                        catch (ex) {
                            return Promise.reject("Failed InstanceAddChildren for parentId \"" + currentChildStepSynerisId + "\" and childId \"" + nextStepSynerisId + "\".");
                        }
                    });
                };
                for (let connector of currentDiagram.connectors) {
                    if (connector.sourceId === currentChildStep.id) {
                        // Found a diagram connector, get target syneris id
                        let nextStepSynerisId;
                        let nextStepLabel;
                        for (let stepNode of currentDiagram.stepNodes) {
                            if (stepNode.id === connector.targetId) {
                                nextStepSynerisId = stepNode.synerisId;
                                nextStepLabel = stepNode.label;
                                break;
                            }
                        }
                        if (synerisNextStepHandledIds.indexOf(nextStepSynerisId) === -1) {
                            // Diagram connector is missing in syneris
                            if (isSave) {
                                // Always create syneris connection
                                try {
                                    yield addNextStep(currentChildStep.synerisId, nextStepSynerisId);
                                }
                                catch (ex) {
                                    return Promise.reject(ex);
                                }
                            }
                            else {
                                // Ask user
                                let choiceId = yield Utilities_1.synUtil.choice({
                                    allowCancel: false,
                                    text: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("processmap.choiceaddsynerisconnectonorremovediagramconnector")), currentChildStep.label, nextStepLabel),
                                    options: [
                                        {
                                            id: 1,
                                            text: Utilities_1.synUtil.Strings.getValue("processmap.addsynerisconnection"),
                                        }, {
                                            id: 2,
                                            text: Utilities_1.synUtil.Strings.getValue("processmap.removediagramconnector"),
                                        }
                                    ],
                                });
                                if (choiceId === 1) {
                                    // Add nextStep
                                    try {
                                        yield addNextStep(currentChildStep.synerisId, nextStepSynerisId);
                                    }
                                    catch (ex) {
                                        return Promise.reject(ex);
                                    }
                                }
                                else if (choiceId === 2)
                                    // Remove connector from diagram
                                    that.removeConnector(currentDiagram, connector);
                            }
                        }
                    }
                }
                stepNodesIndex += 1;
                currentChildStep = currentDiagram.stepNodes[stepNodesIndex];
            }
            // Save the layout another time (possible changes due to conflict resolutions) if it's valid
            if (that.checkStepsDiagramIsValid(currentDiagram)) {
                that.m_instance.items["ceproclk.layout"].valueAsString = JSON.stringify(currentDiagram);
                try {
                    const instTmp = yield Utilities_1.synUtil.getAJAXDataAsync({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                        requestData: { instance: JSON.stringify(that.m_instance.toJSON()) },
                    });
                    that.m_instance = yield Instance_1.Instance.fromJSON(instTmp);
                }
                catch (ex) {
                    that.m_layoutSaveFailed = true;
                    return Promise.reject("Layout save after conflict resolution failed");
                }
            }
            else
                // Don't save, just warn the user
                Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("processmap.invalidsteps"));
            that.m_diagramToLoad = currentDiagram;
            // Add new synerisIds to the syncFusion diagram nodes on save
            if (isSave) {
                for (let step of currentDiagram.stepNodes) {
                    if (step.synerisId) {
                        for (let node of that.m_diagram.nodes) {
                            if (node.id === step.id) {
                                node.data["id"] = step.synerisId;
                                break;
                            }
                        }
                    }
                }
            }
            return Promise.resolve();
        });
    }
    checkProcessDiagramIsValid(diagramJSON) {
        // Check for processes without label
        for (let processNode of diagramJSON.processNodes)
            if (processNode.label === "")
                return false;
        return true;
    }
    checkStepsDiagramIsValid(diagramJSON) {
        if (diagramJSON.stepNodes.length === 0 && diagramJSON.connectors.length === 0)
            return true;
        // Check for steps without label
        for (let stepNode of diagramJSON.stepNodes) {
            if (stepNode.label === "") {
                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("processmap.invalidstepslabel"));
                return false;
            }
        }
        // Check for dangling connectors
        for (let connector of diagramJSON.connectors) {
            if (connector.sourceId === "" || connector.targetId === "") {
                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("processmap.invalidstepsdanglingconnector"));
                return false;
            }
        }
        // Check for connectors that aren't unique
        let connectorList = [];
        for (let connector of diagramJSON.connectors) {
            let connectorTuple = [connector.sourceId, connector.targetId];
            let connectorExists = connectorList.find((element) => {
                if (element[0] === connectorTuple[0] && element[1] === connectorTuple[1])
                    return true;
                else
                    return false;
            });
            if (connectorExists) {
                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("processmap.invalidstepsduplicateconnector"));
                return false;
            }
            else
                connectorList.push(connectorTuple);
        }
        // Find startNode
        let startNode;
        for (let node of diagramJSON.stepNodes) {
            // Check if node has in-connector
            let isStartNode = true;
            for (let connector of diagramJSON.connectors) {
                if (connector.targetId === node.id) {
                    isStartNode = false;
                    break;
                }
            }
            if (isStartNode) {
                startNode = node;
                break;
            }
        }
        if (startNode == undefined) {
            Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("processmap.invalidstepsnostartnode"));
            return false;
        }
        // Traverse based on startNode, check if all nodes are hit, has to be recursive due to allowed branching
        let traverseSteps = function (visitedNodeIds, pathNodeIds, currentNode) {
            // Create copy of path due to branching
            let pathNodeIdsCopy = pathNodeIds.slice();
            // Add current node to path
            pathNodeIdsCopy.push(currentNode.id);
            // Add current node to visited nodes if it's not already there
            if (visitedNodeIds.indexOf(currentNode.id) === -1)
                visitedNodeIds.push(currentNode.id);
            // Find connectors with currentNode as source
            for (let connector of diagramJSON.connectors)
                if (connector.sourceId === currentNode.id)
                    for (let node of diagramJSON.stepNodes)
                        if (node.id === connector.targetId && pathNodeIds.indexOf(node.id) === -1)
                            traverseSteps(visitedNodeIds, pathNodeIdsCopy, node);
        };
        let visitedNodeIds = [];
        traverseSteps(visitedNodeIds, [], startNode);
        if (visitedNodeIds.length !== diagramJSON.stepNodes.length) {
            Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("processmap.invalidstepsnotallconnected"));
            return false;
        }
        return true;
    }
    makeCrumElement(parentId, label) {
        let that = this;
        let root = document.createElement('li');
        let typeId = parseInt(parentId.split("|")[2]);
        let relIds;
        let relIdsTmp = Utilities_1.synUtil.Configs.getValue("processmap.showrelids", "", typeId);
        if (relIdsTmp.length)
            relIds = relIdsTmp.split("|").map(r => parseInt(r, 10));
        root.innerHTML = '<a id=parentId role="button" ><li itemprop="title">' + label + '</li></a>';
        root.onclick = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield that.m_$tabs.synTabs("setParentAsync", parentId, undefined, relIds);
                that.MainMenu.synMenu("revalidate");
                that.updateBreadCrumps(parentId);
            });
        };
        return root;
    }
    updateBreadCrumps(parentId) {
        let that = this;
        if (parentId != undefined)
            for (let i = that.m_bredCrumpList.length - 1; i >= 0; i--) {
                if (that.m_bredCrumpList[i]["id"] === parentId)
                    break;
                else
                    that.m_bredCrumpList.splice(i);
            }
        $("#processMapRelationMenu #processMapBreadCrumb").empty();
        for (let j = 0; j < that.m_bredCrumpList.length; j++)
            $("#processMapRelationMenu #processMapBreadCrumb").append(that.makeCrumElement(that.m_bredCrumpList[j]["id"], that.m_bredCrumpList[j]["label"]));
    }
    selectionChanged($elem, parentId, parentRelId, ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let breadCrump;
            // SelectionContextStorage.clearSelectionStore(SelectionEnabledViews.processmap);
            let promise = new Promise(function (resolve) {
                Utilities_1.synUtil.getAJAXData({
                    method: "GET",
                    url: Utilities_1.synUtil.getWSUrl("Instance") + parentId,
                    done(data) {
                        breadCrump = {
                            "id": parentId,
                            "label": data.items["cgdocument.doclabel"].valueAsString
                        };
                        resolve(breadCrump);
                    },
                });
            });
            promise.then(function (data) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (ids == undefined && $elem.m_bredCrumpList.filter(e => e.id === parentId).length <= 0) {
                        $elem.m_bredCrumpList = [];
                        $elem.m_bredCrumpList.push(breadCrump);
                        yield $elem.updateBreadCrumps(parentId);
                    }
                });
            });
            // TODO:
            //that.setSelectionContext(...);
        });
    }
    rowDoubleClicked($elem, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let breadCrump;
            let promise = new Promise(function (resolve) {
                Utilities_1.synUtil.getAJAXData({
                    method: "GET",
                    url: Utilities_1.synUtil.getWSUrl("Instance") + id,
                    done(data) {
                        breadCrump = {
                            "id": id,
                            "label": data.items["cgdocument.doclabel"].valueAsString
                        };
                        resolve(breadCrump);
                    }
                });
            });
            promise.then(function (data) {
                let action = Utilities_1.synUtil.Configs.getValue("webtoolkitlistdblclickaction", undefined, parseInt(id.split("|")[2], 10));
                if (action === "navigate") {
                    let typeId = parseInt(id.split("|")[2]);
                    let typeIdRelIds = Utilities_1.synUtil.Configs.getValue("processmap.showrelids", "", typeId);
                    $elem.m_$tabs.synTabs("setParent", id, undefined, false, typeIdRelIds);
                    $elem.MainMenu.synMenu("revalidate");
                    $elem.m_bredCrumpList.push(data);
                    $elem.updateBreadCrumps();
                }
            });
        });
    }
    getAllCategories() {
        let d = $.Deferred();
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("GetAllCategories"),
            done(data) {
                d.resolve(data);
            }
        });
        return d.promise();
    }
    mapCategories() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let categories = yield that.getAllCategories();
            for (let key in categories) {
                let value = categories[key];
                that.m_categoryList[value["id"]] = value["parentId"];
            }
        });
    }
    hasValidRelid(parentInstance, childInstance) {
        let that = this;
        let childRelId = childInstance.items["cgdocstructure.structuretype"].valueToString();
        let parentTypeId = parentInstance.items["cgdocument.typeid"].valueToString();
        if (parentTypeId === that.m_typeIdProcessMap) {
            if (childRelId === that.m_processMapRelIdProcesses)
                return true;
        }
        else if (parentTypeId === that.m_typeIdProcess) {
            if (childRelId === that.m_processRelIdProcesses || childRelId === that.m_processRelIdProcessSteps)
                return true;
        }
        else if (parentTypeId === that.m_typeIdProcessStep) {
            if (childRelId === that.m_stepRelIdPrevNextStep)
                return true;
        }
        return false;
    }
    setRelationInstance(id) {
        let that = this;
        if (that.m_$tabs && that.m_$tabs.synTabs("isInitialized")) {
            if (id) {
                if (id !== that.m_activeRelationId) {
                    let relIds = [];
                    let typeId = parseInt(id.split("|")[2]);
                    let typeIdRelIds = Utilities_1.synUtil.Configs.getValue("processmap.showrelids", "", typeId);
                    if (typeIdRelIds !== "")
                        relIds = typeIdRelIds.split("|").map(Number);
                    that.m_activeRelationId = id;
                    let relIdToSet;
                    if (relIds.indexOf(that.m_relId) !== -1)
                        relIdToSet = that.m_relId;
                    else if (relIds.length)
                        relIdToSet = relIds[0];
                    that.m_$tabs.synTabs("setParentAsync", id, relIdToSet, relIds);
                }
            }
            else
                that.m_$tabs.synTabs("setParentAsync", undefined);
        }
    }
}
exports.processmap = processmap;
